"use strict";

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
(function () {
  var _React = React,
    useState = _React.useState,
    useEffect = _React.useEffect,
    useRef = _React.useRef;

  // `initialMode` / `initialPremadeCategory` are OPTIONAL. They exist so a particular panel can be
  // opened directly — used by the Node verification harness to render the locked Restricted section
  // without simulating clicks, and available for deep-linking a mode later. Both default to the
  // normal first-load state, so nothing changes for a real user.

  // =========================================================================================
  // PATIENT SCREENS on the start screen. The session code, and (folded away until wanted) the
  // Screens panel: every screen that joins is numbered, and this is where each one is told what
  // to show (data/screens/screenspanel.js). It works the same at any time during a scenario.
  // =========================================================================================
  var SessionSetupCard = function SessionSetupCard(_ref) {
    var sessionID = _ref.sessionID,
      onJoinClick = _ref.onJoinClick,
      onNewSessionCode = _ref.onNewSessionCode;
    var _window = window,
      Button = _window.Button,
      Lucide = _window.Lucide,
      ScreensPanel = _window.ScreensPanel,
      ScreenLinkContext = _window.ScreenLinkContext,
      screensSummary = _window.screensSummary;
    var link = React.useContext(ScreenLinkContext);
    // Closed until wanted: screens can be connected now or at any time during a scenario.
    var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      open = _useState2[0],
      setOpen = _useState2[1];
    var summary = screensSummary(link);
    var count = link ? link.screens.filter(function (s) {
      return s.connected && s.n;
    }).length : 0;
    return /*#__PURE__*/React.createElement("section", {
      className: "bg-slate-900 border border-slate-700 p-4 rounded-lg space-y-4",
      "aria-label": "Patient screens",
      "data-testid": "setup-card"
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex flex-wrap items-center gap-3 justify-between"
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex items-center gap-4"
    }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
      className: "text-[10px] uppercase text-sky-400 font-bold"
    }, "Session Code"), /*#__PURE__*/React.createElement("div", {
      className: "text-2xl font-mono font-bold text-white tracking-widest",
      "data-testid": "session-code"
    }, sessionID)), /*#__PURE__*/React.createElement("div", {
      className: "text-xs text-slate-400 max-w-sm leading-snug",
      "data-testid": "setup-summary"
    }, count ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("b", {
      className: "text-slate-200"
    }, count, " patient screen", count > 1 ? 's' : '', " connected."), " ", summary) : /*#__PURE__*/React.createElement(React.Fragment, null, "The candidates' screens join with this code. Connect them now, or later from ", /*#__PURE__*/React.createElement("b", null, "Screens"), " during a scenario."))), /*#__PURE__*/React.createElement("button", {
      type: "button",
      onClick: function onClick() {
        return setOpen(function (o) {
          return !o;
        });
      },
      "aria-expanded": open,
      "data-testid": "setup-toggle",
      className: "h-9 px-3 rounded font-bold text-sm flex items-center gap-1.5 border transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-sky-400 ".concat(open ? 'bg-slate-700 border-slate-600 text-slate-200' : 'bg-sky-700 hover:bg-sky-600 border-sky-500 text-white')
    }, /*#__PURE__*/React.createElement(Lucide, {
      icon: "monitor",
      className: "w-4 h-4"
    }), " Connect patient screens ", /*#__PURE__*/React.createElement(Lucide, {
      icon: open ? 'chevron-down' : 'chevron-right',
      className: "w-3 h-3"
    }))), open && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("h2", {
      id: "setup-heading",
      className: "text-lg font-bold text-white"
    }, "Patient screens"), /*#__PURE__*/React.createElement(ScreensPanel, {
      sessionID: sessionID
    }), /*#__PURE__*/React.createElement("div", {
      className: "flex flex-wrap items-center gap-2 border-t border-slate-800 pt-3 justify-end"
    }, /*#__PURE__*/React.createElement(Button, {
      onClick: onJoinClick,
      variant: "outline",
      className: "h-9 text-xs whitespace-nowrap"
    }, "Use this device as a patient screen"), onNewSessionCode && /*#__PURE__*/React.createElement(Button, {
      onClick: function onClick() {
        if (window.confirm('Start a new session code? Every patient screen paired to ' + sessionID + ' will need to join the new code.')) onNewSessionCode();
      },
      variant: "outline",
      className: "h-9 text-xs whitespace-nowrap",
      title: "Generate a new session code for a new group"
    }, "New code"))));
  };
  var SetupScreen = function SetupScreen(_ref2) {
    var onGenerate = _ref2.onGenerate,
      savedState = _ref2.savedState,
      onResume = _ref2.onResume,
      sessionID = _ref2.sessionID,
      onJoinClick = _ref2.onJoinClick,
      onQuickSim = _ref2.onQuickSim,
      onDefibSim = _ref2.onDefibSim,
      onVentSim = _ref2.onVentSim,
      onNewSessionCode = _ref2.onNewSessionCode,
      auth = _ref2.auth,
      initialMode = _ref2.initialMode,
      initialPremadeCategory = _ref2.initialPremadeCategory,
      _ref2$onStartScreen = _ref2.onStartScreen,
      onStartScreen = _ref2$onStartScreen === void 0 ? null : _ref2$onStartScreen;
    var _window2 = window,
      ALL_SCENARIOS = _window2.ALL_SCENARIOS,
      HUMAN_FACTOR_CHALLENGES = _window2.HUMAN_FACTOR_CHALLENGES,
      Button = _window2.Button,
      Lucide = _window2.Lucide,
      generateHistory = _window2.generateHistory,
      estimateWeight = _window2.estimateWeight,
      calculateWetflag = _window2.calculateWetflag,
      generateVbg = _window2.generateVbg,
      generateName = _window2.generateName,
      getScenarioPreviewText = _window2.getScenarioPreviewText,
      formatProfileTemplate = _window2.formatProfileTemplate,
      validateBuilderField = _window2.validateBuilderField,
      BUILDER_LIMITS = _window2.BUILDER_LIMITS,
      HumanFactorBadge = _window2.HumanFactorBadge;
    var _useState3 = useState(initialMode || null),
      _useState4 = _slicedToArray(_useState3, 2),
      mode = _useState4[0],
      setMode = _useState4[1];
    var _useState5 = useState('Medical'),
      _useState6 = _slicedToArray(_useState5, 2),
      category = _useState6[0],
      setCategory = _useState6[1];
    var _useState7 = useState('Any'),
      _useState8 = _slicedToArray(_useState7, 2),
      age = _useState8[0],
      setAge = _useState8[1];
    var _useState9 = useState('Any'),
      _useState0 = _slicedToArray(_useState9, 2),
      acuity = _useState0[0],
      setAcuity = _useState0[1];
    var _useState1 = useState('hf0'),
      _useState10 = _slicedToArray(_useState1, 2),
      hf = _useState10[0],
      setHf = _useState10[1];
    var _useState11 = useState(initialPremadeCategory || null),
      _useState12 = _slicedToArray(_useState11, 2),
      premadeCategory = _useState12[0],
      setPremadeCategory = _useState12[1];
    // My scenarios: the signed-in account's saved scenarios (userScenarios/{uid}, see
    // data/auth.js UserScenarios), plus any still saved only in this browser from before.
    var _useState13 = useState([]),
      _useState14 = _slicedToArray(_useState13, 2),
      customScenarios = _useState14[0],
      setCustomScenarios = _useState14[1];
    var _useState15 = useState('idle'),
      _useState16 = _slicedToArray(_useState15, 2),
      myStatus = _useState16[0],
      setMyStatus = _useState16[1]; // idle | loading | ready | denied | unavailable
    var _useState17 = useState(function () {
        return window.UserScenarios ? window.UserScenarios.readLegacy() : [];
      }),
      _useState18 = _slicedToArray(_useState17, 2),
      legacyScenarios = _useState18[0],
      setLegacyScenarios = _useState18[1];
    var _useState19 = useState(null),
      _useState20 = _slicedToArray(_useState19, 2),
      myNotice = _useState20[0],
      setMyNotice = _useState20[1];
    var _useState21 = useState(false),
      _useState22 = _slicedToArray(_useState21, 2),
      myAuthOpen = _useState22[0],
      setMyAuthOpen = _useState22[1];
    var _useState23 = useState(false),
      _useState24 = _slicedToArray(_useState23, 2),
      saving = _useState24[0],
      setSaving = _useState24[1];
    var _useState25 = useState(false),
      _useState26 = _slicedToArray(_useState25, 2),
      showWetflag = _useState26[0],
      setShowWetflag = _useState26[1];

    // ---- WAVE 4b / PART A: QUICK SIM launch options -------------------------------------
    // The facilitator may OPTIONALLY set age/weight/sex/name so WETFLAG and paediatric
    // energy/dosing still work; leaving everything alone gives a sensible adult (40y, 70 kg-ish
    // adult physiology, sinus rhythm). Blank strings mean "use the default", which is why these
    // are strings rather than numbers.
    var _useState27 = useState('40'),
      _useState28 = _slicedToArray(_useState27, 2),
      qsAge = _useState28[0],
      setQsAge = _useState28[1];
    var _useState29 = useState(''),
      _useState30 = _slicedToArray(_useState29, 2),
      qsWeight = _useState30[0],
      setQsWeight = _useState30[1];
    var _useState31 = useState('Male'),
      _useState32 = _slicedToArray(_useState31, 2),
      qsSex = _useState32[0],
      setQsSex = _useState32[1];
    var _useState33 = useState(''),
      _useState34 = _slicedToArray(_useState33, 2),
      qsName = _useState34[0],
      setQsName = _useState34[1];
    var _useState35 = useState('Sinus Rhythm'),
      _useState36 = _slicedToArray(_useState35, 2),
      qsRhythm = _useState36[0],
      setQsRhythm = _useState36[1];

    // ---- WAVE 4b / PART C: restricted (RCUK) scenarios ----------------------------------
    // Loaded FROM FIREBASE at runtime, never bundled. Shipped empty but fully wired.
    var _useState37 = useState({
        phase: 'idle',
        scenarios: [],
        reason: null
      }),
      _useState38 = _slicedToArray(_useState37, 2),
      restricted = _useState38[0],
      setRestricted = _useState38[1];
    // The locked panel used to tell a signed-out user to "request access below"
    // when the request-access button only renders once signed in, so it promised a control that was
    // not on screen. The panel now carries its OWN sign-in button, and the instructions for each of
    // the three states name only controls that are actually visible in that state.
    var _useState39 = useState(false),
      _useState40 = _slicedToArray(_useState39, 2),
      restrictedAuthOpen = _useState40[0],
      setRestrictedAuthOpen = _useState40[1];
    // Course filter and the open mark sheet. Course scenarios carry `course` (e.g. 'ETC', 'ALS') and
    // `group` (a workshop), so the list is grouped instead of one long column.
    var _useState41 = useState('All'),
      _useState42 = _slicedToArray(_useState41, 2),
      restrictedCourse = _useState42[0],
      setRestrictedCourse = _useState42[1];
    var _useState43 = useState(null),
      _useState44 = _slicedToArray(_useState43, 2),
      markSheetFor = _useState44[0],
      setMarkSheetFor = _useState44[1];
    var _useState45 = useState(null),
      _useState46 = _slicedToArray(_useState45, 2),
      buildId = _useState46[0],
      setBuildId = _useState46[1];
    var _useState47 = useState(""),
      _useState48 = _slicedToArray(_useState47, 2),
      buildTitle = _useState48[0],
      setBuildTitle = _useState48[1];
    var _useState49 = useState(""),
      _useState50 = _slicedToArray(_useState49, 2),
      buildName = _useState50[0],
      setBuildName = _useState50[1];
    var _useState51 = useState(40),
      _useState52 = _slicedToArray(_useState51, 2),
      buildAge = _useState52[0],
      setBuildAge = _useState52[1];
    var _useState53 = useState("Male"),
      _useState54 = _slicedToArray(_useState53, 2),
      buildSex = _useState54[0],
      setBuildSex = _useState54[1];
    var _useState55 = useState("Medical"),
      _useState56 = _slicedToArray(_useState55, 2),
      buildCat = _useState56[0],
      setBuildCat = _useState56[1];
    var _useState57 = useState("A 40-year-old male with chest pain."),
      _useState58 = _slicedToArray(_useState57, 2),
      buildDesc = _useState58[0],
      setBuildDesc = _useState58[1];
    var _useState59 = useState("Hypertension"),
      _useState60 = _slicedToArray(_useState59, 2),
      buildPMH = _useState60[0],
      setBuildPMH = _useState60[1];
    var _useState61 = useState("Nil"),
      _useState62 = _slicedToArray(_useState61, 2),
      buildDhx = _useState62[0],
      setBuildDhx = _useState62[1];
    var _useState63 = useState("NKDA"),
      _useState64 = _slicedToArray(_useState63, 2),
      buildAllergies = _useState64[0],
      setBuildAllergies = _useState64[1];
    var _useState65 = useState("Intermediate"),
      _useState66 = _slicedToArray(_useState65, 2),
      buildDifficulty = _useState66[0],
      setBuildDifficulty = _useState66[1];
    var _useState67 = useState(""),
      _useState68 = _slicedToArray(_useState67, 2),
      buildCxrUrl = _useState68[0],
      setBuildCxrUrl = _useState68[1];
    var _useState69 = useState(""),
      _useState70 = _slicedToArray(_useState69, 2),
      buildCtUrl = _useState70[0],
      setBuildCtUrl = _useState70[1];
    // What the monitor's investigation buttons give in this scenario ({ type: choice }, see
    // INVESTIGATIONS.setResult); empty = the scenario's default results.
    var _useState71 = useState({}),
      _useState72 = _slicedToArray(_useState71, 2),
      buildInvResults = _useState72[0],
      setBuildInvResults = _useState72[1];
    var _useState73 = useState(null),
      _useState74 = _slicedToArray(_useState73, 2),
      buildInvEditing = _useState74[0],
      setBuildInvEditing = _useState74[1];
    var _useState75 = useState(""),
      _useState76 = _slicedToArray(_useState75, 2),
      buildLearningObj = _useState76[0],
      setBuildLearningObj = _useState76[1];
    var _useState77 = useState(""),
      _useState78 = _slicedToArray(_useState77, 2),
      buildCustomActions = _useState78[0],
      setBuildCustomActions = _useState78[1];
    var _useState79 = useState({
        hr: 80,
        bpSys: 120,
        rr: 16,
        spO2: 98,
        temp: 37,
        gcs: 15,
        rhythm: "Sinus Rhythm"
      }),
      _useState80 = _slicedToArray(_useState79, 2),
      buildVitals = _useState80[0],
      setBuildVitals = _useState80[1];

    // The freetext brief used to be independent of the structured fields, so a scenario could read
    // "40-year-old male" while the age field said 7. Keep it derived until the user edits it, then
    // flag it as stale instead of silently overwriting their words.
    var _useState81 = useState(false),
      _useState82 = _slicedToArray(_useState81, 2),
      descDirty = _useState82[0],
      setDescDirty = _useState82[1];
    var autoDesc = function autoDesc(a, s, t) {
      return "A ".concat(a, "-year-old ").concat(String(s || 'patient').toLowerCase(), " with ").concat((t || 'an undifferentiated presentation').toLowerCase(), ".");
    };
    useEffect(function () {
      if (!descDirty) setBuildDesc(autoDesc(buildAge, buildSex, buildTitle));
    }, [buildAge, buildSex, buildTitle, descDirty]);
    var descStale = descDirty && !String(buildDesc).includes(String(buildAge));
    var builderErrors = {
      age: validateBuilderField('age', buildAge),
      hr: validateBuilderField('hr', buildVitals.hr),
      bpSys: validateBuilderField('bpSys', buildVitals.bpSys),
      rr: validateBuilderField('rr', buildVitals.rr),
      spO2: validateBuilderField('spO2', buildVitals.spO2),
      gcs: validateBuilderField('gcs', buildVitals.gcs),
      temp: validateBuilderField('temp', buildVitals.temp)
    };
    var builderInvalid = Object.values(builderErrors).some(Boolean);
    var FieldError = function FieldError(_ref3) {
      var msg = _ref3.msg;
      return msg ? /*#__PURE__*/React.createElement("div", {
        className: "text-[10px] text-red-400 mt-0.5"
      }, msg) : null;
    };
    var fieldClass = function fieldClass(msg) {
      return "w-full bg-slate-900 border rounded p-2 text-white placeholder-slate-400 ".concat(msg ? 'border-red-500' : 'border-slate-600');
    };
    var scenariosAvailable = ALL_SCENARIOS && ALL_SCENARIOS.length > 0;

    // JSON.parse succeeding says nothing about shape. A hand-edited localStorage entry or an
    // arbitrary .json file used to be accepted wholesale and then crashed the scenario list on
    // the first `.title.toLowerCase()`.
    var isValidScenarioShape = function isValidScenarioShape(s) {
      return !!s && _typeof(s) === 'object' && !Array.isArray(s) && typeof s.id === 'string' && s.id.length > 0 && typeof s.title === 'string' && s.title.length > 0;
    };
    var sanitiseScenarioList = function sanitiseScenarioList(raw) {
      var list = Array.isArray(raw) ? raw : [raw];
      return list.filter(isValidScenarioShape);
    };

    // Saving needs an account. Signed out, the Builder still runs a scenario, it just is not kept.
    var US = window.UserScenarios || null;
    var accountsOn = !!(US && auth && auth.available);
    var uid = accountsOn && auth.phase === 'signedIn' && auth.user && auth.user.uid || null;
    var canSave = !!uid && myStatus === 'ready';
    var AuthModalComponent = window.AuthModal || null;
    useEffect(function () {
      if (!uid || !US) {
        setCustomScenarios([]);
        setMyStatus('idle');
        if (US) US.cache = [];
        return;
      }
      setMyStatus('loading');
      var stop = US.subscribe(uid, function (list) {
        setCustomScenarios(list);
        setMyStatus('ready');
      }, function (reason) {
        return setMyStatus(reason);
      });
      return function () {
        stop();
        US.cache = [];
      };
    }, [uid]);
    useEffect(function () {
      if (uid) {
        setMyAuthOpen(false);
        setRestrictedAuthOpen(false);
      }
    }, [uid]);
    var saveFailed = function saveFailed(e) {
      return alert('Could not save to your account: ' + (e && e.message || 'the database refused it') + '.');
    };
    var addingLegacy = useRef(false); // a second click while the first is saving does nothing
    var addLegacyToAccount = function addLegacyToAccount() {
      if (!canSave || !legacyScenarios.length || addingLegacy.current) return;
      var inAccount = new Set(customScenarios.map(function (c) {
        return c.id;
      }));
      if (customScenarios.length + legacyScenarios.filter(function (l) {
        return !inAccount.has(l.id);
      }).length > US.MAX) {
        alert("Your account holds up to ".concat(US.MAX, " scenarios. Delete some first, then add these."));
        return;
      }
      addingLegacy.current = true;
      US.saveMany(uid, legacyScenarios, customScenarios).then(function (n) {
        US.clearLegacy();
        setLegacyScenarios([]);
        setMyNotice(n ? "Added ".concat(n, " scenario(s) from this device to your account.") : 'Those scenarios were already in your account.');
      })["catch"](saveFailed)["finally"](function () {
        addingLegacy.current = false;
      });
    };
    var discardLegacy = function discardLegacy() {
      if (!window.confirm("Remove ".concat(legacyScenarios.length, " scenario(s) saved on this device? They are not in your account, so this cannot be undone."))) return;
      US.clearLegacy();
      setLegacyScenarios([]);
    };

    // The scenario last loaded into the Builder. Saving it again keeps any field the Builder does
    // not show (an imported scenario's evolution or investigations, for example).
    var buildOrigRef = useRef(null);
    // A blank Builder. After a save the next scenario built is a new one, not the saved one again.
    var newBuilder = function newBuilder() {
      buildOrigRef.current = null;
      setBuildId(null);
      setBuildTitle("");
      setBuildName("");
      setBuildAge(40);
      setBuildSex("Male");
      setBuildCat("Medical");
      setDescDirty(false);
      setBuildPMH("Hypertension");
      setBuildDhx("Nil");
      setBuildAllergies("NKDA");
      setBuildDifficulty("Intermediate");
      setBuildCxrUrl("");
      setBuildCtUrl("");
      setBuildInvResults({});
      setBuildInvEditing(null);
      setBuildLearningObj("");
      setBuildCustomActions("");
      setBuildVitals({
        hr: 80,
        bpSys: 120,
        rr: 16,
        spO2: 98,
        temp: 37,
        gcs: 15,
        rhythm: "Sinus Rhythm"
      });
      setHf('hf0');
    };
    var loadIntoBuilder = function loadIntoBuilder(s) {
      var _s$patientAge, _s$patientAge2, _s$customImages, _s$customImages2, _s$instructorBrief, _ref4, _s$vitalsMod$hr, _s$vitalsMod, _s$vitals, _ref5, _s$vitalsMod$bpSys, _s$vitalsMod2, _s$vitals2, _ref6, _s$vitalsMod$rr, _s$vitalsMod3, _s$vitals3, _ref7, _s$vitalsMod$spO, _s$vitalsMod4, _s$vitals4, _ref8, _s$vitalsMod$temp, _s$vitalsMod5, _s$vitals5, _ref9, _s$vitalsMod$gcs, _s$vitalsMod6, _s$vitals6, _s$ecg;
      buildOrigRef.current = s;
      setBuildId(s.id || "CUST_".concat(Date.now()));
      setHf(s.hf && s.hf.id || 'hf0');
      setBuildTitle(s.title);
      setBuildName(s.patientName || "");
      setBuildAge((_s$patientAge = s.patientAge) !== null && _s$patientAge !== void 0 ? _s$patientAge : 40); // a newborn is 0, not 40
      setBuildSex(s.sex || "Male");
      setBuildCat(s.category);
      setBuildDesc(formatProfileTemplate(s.patientProfileTemplate || s.profile, (_s$patientAge2 = s.patientAge) !== null && _s$patientAge2 !== void 0 ? _s$patientAge2 : window.getPreviewAge(s), s.sex || 'Male'));
      setDescDirty(true);
      setBuildPMH(Array.isArray(s.pmh) ? s.pmh.join(", ") : s.pmh || "");
      setBuildDhx(Array.isArray(s.dhx) ? s.dhx.join(", ") : s.dhx || "Nil");
      setBuildAllergies(Array.isArray(s.allergies) ? s.allergies.join(", ") : s.allergies || "NKDA");
      setBuildDifficulty(s.difficulty || "Intermediate");
      setBuildCxrUrl(((_s$customImages = s.customImages) === null || _s$customImages === void 0 ? void 0 : _s$customImages.xray) || "");
      setBuildCtUrl(((_s$customImages2 = s.customImages) === null || _s$customImages2 === void 0 ? void 0 : _s$customImages2.ct) || "");
      setBuildInvResults(s.invResults && _typeof(s.invResults) === 'object' ? s.invResults : {});
      setBuildLearningObj(Array.isArray(s.learningObjectives) ? s.learningObjectives.join(', ') : ((_s$instructorBrief = s.instructorBrief) === null || _s$instructorBrief === void 0 || (_s$instructorBrief = _s$instructorBrief.learningObjectives) === null || _s$instructorBrief === void 0 ? void 0 : _s$instructorBrief.join(', ')) || '');
      setBuildCustomActions(Array.isArray(s.customActions) ? s.customActions.join(', ') : '');
      // ?? not ||: an arrest's HR 0 / BP 0 must survive into the Builder (|| turned a VF
      // arrest into VF with HR 80 and BP 120).
      setBuildVitals({
        hr: (_ref4 = (_s$vitalsMod$hr = (_s$vitalsMod = s.vitalsMod) === null || _s$vitalsMod === void 0 ? void 0 : _s$vitalsMod.hr) !== null && _s$vitalsMod$hr !== void 0 ? _s$vitalsMod$hr : (_s$vitals = s.vitals) === null || _s$vitals === void 0 ? void 0 : _s$vitals.hr) !== null && _ref4 !== void 0 ? _ref4 : 80,
        bpSys: (_ref5 = (_s$vitalsMod$bpSys = (_s$vitalsMod2 = s.vitalsMod) === null || _s$vitalsMod2 === void 0 ? void 0 : _s$vitalsMod2.bpSys) !== null && _s$vitalsMod$bpSys !== void 0 ? _s$vitalsMod$bpSys : (_s$vitals2 = s.vitals) === null || _s$vitals2 === void 0 ? void 0 : _s$vitals2.bpSys) !== null && _ref5 !== void 0 ? _ref5 : 120,
        rr: (_ref6 = (_s$vitalsMod$rr = (_s$vitalsMod3 = s.vitalsMod) === null || _s$vitalsMod3 === void 0 ? void 0 : _s$vitalsMod3.rr) !== null && _s$vitalsMod$rr !== void 0 ? _s$vitalsMod$rr : (_s$vitals3 = s.vitals) === null || _s$vitals3 === void 0 ? void 0 : _s$vitals3.rr) !== null && _ref6 !== void 0 ? _ref6 : 16,
        spO2: (_ref7 = (_s$vitalsMod$spO = (_s$vitalsMod4 = s.vitalsMod) === null || _s$vitalsMod4 === void 0 ? void 0 : _s$vitalsMod4.spO2) !== null && _s$vitalsMod$spO !== void 0 ? _s$vitalsMod$spO : (_s$vitals4 = s.vitals) === null || _s$vitals4 === void 0 ? void 0 : _s$vitals4.spO2) !== null && _ref7 !== void 0 ? _ref7 : 98,
        temp: (_ref8 = (_s$vitalsMod$temp = (_s$vitalsMod5 = s.vitalsMod) === null || _s$vitalsMod5 === void 0 ? void 0 : _s$vitalsMod5.temp) !== null && _s$vitalsMod$temp !== void 0 ? _s$vitalsMod$temp : (_s$vitals5 = s.vitals) === null || _s$vitals5 === void 0 ? void 0 : _s$vitals5.temp) !== null && _ref8 !== void 0 ? _ref8 : 37,
        gcs: (_ref9 = (_s$vitalsMod$gcs = (_s$vitalsMod6 = s.vitalsMod) === null || _s$vitalsMod6 === void 0 ? void 0 : _s$vitalsMod6.gcs) !== null && _s$vitalsMod$gcs !== void 0 ? _s$vitalsMod$gcs : (_s$vitals6 = s.vitals) === null || _s$vitals6 === void 0 ? void 0 : _s$vitals6.gcs) !== null && _ref9 !== void 0 ? _ref9 : 15,
        rhythm: ((_s$ecg = s.ecg) === null || _s$ecg === void 0 ? void 0 : _s$ecg.type) || "Sinus Rhythm"
      });
      setMode('builder');
    };
    var exportCustomScenarios = function exportCustomScenarios() {
      var list = uid ? customScenarios : legacyScenarios;
      if (!list.length) return alert("No custom scenarios to export.");
      var blob = new Blob([JSON.stringify(list, null, 2)], {
        type: 'application/json'
      });
      var url = URL.createObjectURL(blob);
      var a = document.createElement('a');
      a.href = url;
      a.download = "em_evidence_scenarios_".concat(Date.now(), ".json");
      document.body.appendChild(a);
      a.click();
      a.remove();
      setTimeout(function () {
        return URL.revokeObjectURL(url);
      }, 0);
    };
    var importCustomScenariosFile = function importCustomScenariosFile(e) {
      var file = e.target.files[0];
      if (!file) return;
      if (!canSave) {
        e.target.value = '';
        alert('Sign in to import scenarios into your account.');
        return;
      }
      var reader = new FileReader();
      reader.onerror = function () {
        alert('Could not read the selected scenario file. Please try another JSON export.');
        e.target.value = '';
      };
      reader.onload = function (ev) {
        try {
          var parsed = JSON.parse(ev.target.result);
          var rawCount = Array.isArray(parsed) ? parsed.length : 1;
          var list = sanitiseScenarioList(parsed);
          var rejected = rawCount - list.length;
          if (list.length === 0) {
            alert('Import failed: no valid scenarios found (each needs an id and a title).');
            return;
          }
          US.saveMany(uid, list, customScenarios).then(function (added) {
            var full = list.length > added && customScenarios.length + added >= US.MAX;
            alert("Imported ".concat(added, " new scenario(s) into your account.") + (rejected > 0 ? " ".concat(rejected, " skipped (invalid shape).") : '') + (full ? " Your account holds up to ".concat(US.MAX, ", so some were not added.") : ''));
          })["catch"](saveFailed);
        } catch (err) {
          alert('Import failed: ' + err.message);
        }
      };
      reader.readAsText(file);
      e.target.value = '';
    };
    var DIFF_COLOURS = {
      Beginner: 'bg-emerald-900/50 text-emerald-400 border-emerald-800',
      Intermediate: 'bg-amber-900/50 text-amber-400 border-amber-800',
      Advanced: 'bg-red-900/50 text-red-400 border-red-800'
    };
    var DiffBadge = function DiffBadge(_ref0) {
      var d = _ref0.d;
      return d ? /*#__PURE__*/React.createElement("span", {
        className: "text-[9px] px-1 rounded border ".concat(DIFF_COLOURS[d] || DIFF_COLOURS.Intermediate)
      }, d.toUpperCase()) : null;
    };

    // run: start it straight away. Signed out it only runs; signed in it is saved first.
    var saveCustomScenario = function saveCustomScenario() {
      var run = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      if (!buildTitle) return alert("Please add a title");
      // Reject rather than clamp: a silently corrected age used to reclassify the scenario as
      // paediatric and produce WETFLAG doses for a patient the facilitator never described.
      var problems = Object.values(builderErrors).filter(Boolean);
      if (problems.length) return alert("Please correct the following before running:\n\n" + problems.join("\n"));
      var finalAge = Number(buildAge);
      var finalName = buildName.trim() || generateName(buildSex);
      var weight = finalAge < 18 ? estimateWeight(finalAge) : null;
      var wetflag = weight ? calculateWetflag(finalAge, weight) : null;
      var bpSys = Number(buildVitals.bpSys);
      var safeVitals = {
        hr: Number(buildVitals.hr),
        bpSys: bpSys,
        rr: Number(buildVitals.rr),
        spO2: Number(buildVitals.spO2),
        temp: Number(buildVitals.temp),
        gcs: Number(buildVitals.gcs),
        bpDia: Math.floor(bpSys * 0.65)
      };
      var newScen = {
        id: buildId && buildId.startsWith('CUST_') ? buildId : "CUST_".concat(Date.now()),
        title: buildTitle,
        category: buildCat,
        ageRange: finalAge < 18 ? "Paediatric" : "Adult",
        acuity: 'Majors',
        patientAge: finalAge,
        patientName: finalName,
        sex: buildSex,
        patientProfileTemplate: buildDesc,
        profile: buildDesc,
        presentingComplaint: buildTitle,
        vitalsMod: safeVitals,
        vitals: safeVitals,
        pmh: buildPMH.split(',').map(function (s) {
          return s.trim();
        }),
        dhx: buildDhx.split(',').map(function (s) {
          return s.trim();
        }),
        allergies: buildAllergies.split(',').map(function (s) {
          return s.trim();
        }),
        difficulty: buildDifficulty,
        customImages: {
          xray: buildCxrUrl || null,
          ct: buildCtUrl || null
        },
        invResults: buildInvResults,
        learningObjectives: buildLearningObj.split(',').map(function (s) {
          return s.trim();
        }).filter(Boolean).length ? buildLearningObj.split(',').map(function (s) {
          return s.trim();
        }).filter(Boolean) : [],
        customActions: buildCustomActions.split(',').map(function (s) {
          return s.trim();
        }).filter(Boolean),
        instructorBrief: {
          progression: "Custom Scenario",
          interventions: [],
          learningObjectives: buildLearningObj.split(',').map(function (s) {
            return s.trim();
          }).filter(Boolean).length ? buildLearningObj.split(',').map(function (s) {
            return s.trim();
          }).filter(Boolean) : []
        },
        vbgClinicalState: "normal",
        ecg: {
          type: buildVitals.rhythm || "Sinus Rhythm",
          findings: buildVitals.rhythm || "Normal"
        },
        chestXray: {
          findings: "Unremarkable"
        },
        weight: weight,
        wetflag: wetflag,
        showWetflag: showWetflag,
        hf: HUMAN_FACTOR_CHALLENGES.find(function (h) {
          return h.id === hf;
        }) || HUMAN_FACTOR_CHALLENGES[0]
      };

      // Editing a saved scenario: keep what the Builder does not show.
      var orig = buildOrigRef.current;
      if (orig && orig.id === newScen.id) Object.keys(orig).forEach(function (k) {
        if (!(k in newScen)) newScen[k] = orig[k];
      });
      if (!canSave) {
        if (run) handleGenerate(newScen);
        return;
      }
      if (!customScenarios.some(function (c) {
        return c.id === newScen.id;
      }) && customScenarios.length >= US.MAX) {
        alert("Your account holds up to ".concat(US.MAX, " scenarios. Delete one to save another.") + (run ? ' This one will run without being saved.' : ''));
        if (run) handleGenerate(newScen);
        return;
      }
      setBuildId(newScen.id);
      if (run) {
        // The write is queued by Firebase, so the run need not wait for it.
        US.save(uid, newScen)["catch"](saveFailed);
        handleGenerate(newScen);
        return;
      }
      setSaving(true);
      // Firebase only confirms a save once the server has it. Offline, it waits for the
      // connection, so say so rather than leaving "Saving…" up with the buttons disabled.
      var done = false;
      var slow = setTimeout(function () {
        if (done) return;
        setSaving(false);
        setMyNotice("Not connected: \"".concat(newScen.title, "\" will save to your account when the connection comes back. Keep this page open until then."));
      }, 10000);
      US.save(uid, newScen).then(function () {
        setMyNotice("Saved \"".concat(newScen.title, "\" to your account."));
        newBuilder();
        setMode('custom');
      })["catch"](saveFailed)["finally"](function () {
        done = true;
        clearTimeout(slow);
        setSaving(false);
      });
    };
    var handleGenerate = function handleGenerate(base) {
      if (!scenariosAvailable) {
        alert("Scenarios failed to load. Please refresh the page.");
        return;
      }
      try {
        var selectedBase = base;
        if (!base && mode === 'random') {
          var pool = ALL_SCENARIOS.filter(function (s) {
            return (category === 'Any' || s.category === category) && (age === 'Any' || s.ageRange === age) && (acuity === 'Any' || s.acuity === acuity);
          });
          if (pool.length === 0) {
            alert("No scenarios match filters.");
            return;
          }
          selectedBase = pool[Math.floor(Math.random() * pool.length)];
        }
        var selectedHf = HUMAN_FACTOR_CHALLENGES.find(function (h) {
          return h.id === hf;
        }) || HUMAN_FACTOR_CHALLENGES[0];
        if (selectedBase.id.startsWith('CUST_')) {
          // Custom scenarios are built at runtime and never pass through processScenarios,
          // so enrich them here. Without this the live observations screen loads with no
          // equipment list, no guideline links, no investigations and no VBG result.
          var enriched = window.enrichScenario ? window.enrichScenario(selectedBase) : selectedBase;
          var ready = _objectSpread(_objectSpread({}, enriched), {}, {
            vbg: enriched.vbg || generateVbg(enriched.vbgClinicalState || "normal"),
            showWetflag: showWetflag,
            hf: selectedBase.hf || selectedHf
          });
          // The Builder's chosen investigation results (shown as changed on the controller,
          // where they can still be changed or undone).
          var I = window.INVESTIGATIONS;
          onGenerate(I && I.applyResultSpecs ? I.applyResultSpecs(ready, selectedBase.invResults) : ready, {});
          return;
        }
        var generated = window.generatePatientFromTemplate(selectedBase, {
          hf: selectedHf,
          showWetflag: showWetflag
        });
        onGenerate(generated, {});
      } catch (err) {
        console.error("Generator Error:", err);
        alert("Error generating scenario: " + err.message);
      }
    };

    // ---- QUICK SIM validation + launch --------------------------------------------------
    // Reuses validateBuilderField (the SAME validator the Builder and the live vitals-control
    // modal use) so an out-of-range age or weight is rejected identically everywhere.
    var qsAgeError = qsAge === '' ? null : validateBuilderField('age', qsAge);
    var qsWeightError = qsWeight === '' ? null : validateBuilderField('weight', qsWeight);
    var qsInvalid = !!(qsAgeError || qsWeightError);
    var qsResolvedAge = qsAge === '' ? 40 : Number(qsAge);
    var qsAutoWeight = !qsWeight && qsResolvedAge < 18 ? estimateWeight(qsResolvedAge) : null;
    var launchQuickSim = function launchQuickSim() {
      if (qsInvalid) return;
      if (!onQuickSim) {
        alert('Quick Sim is unavailable in this build.');
        return;
      }
      onQuickSim({
        age: qsAge === '' ? 40 : Number(qsAge),
        weight: qsWeight === '' ? null : Number(qsWeight),
        sex: qsSex,
        name: qsName,
        rhythm: qsRhythm,
        showWetflag: false // the WETFLAG option is not offered for Quick Sim; a tick left on another tab must not leak in
      });
    };

    // ---- RESTRICTED SECTION -------------------------------------------------------------
    // A clear locked state, a sign-in / request-access path, and NO errors or console
    // noise when Firebase Auth has never been enabled. The client-side check below controls the
    // UI ONLY — the real enforcement is the database rules (database.rules.json), which is why
    // we still attempt the read and treat PERMISSION_DENIED as a normal locked outcome.
    // Each course (ALS, ETC, CABC) has its own entitlement; the section opens if the account holds any.
    var heldCourses = (window.COURSE_ACCESS || [{
      key: 'rcuk'
    }]).map(function (c) {
      return c.key;
    }).filter(function (k) {
      return !!(auth && auth.has && auth.has(k));
    });
    var heldKey = heldCourses.join(',');
    var restrictedUnlocked = heldCourses.length > 0;
    useEffect(function () {
      if (!restrictedUnlocked) {
        setRestricted({
          phase: 'locked',
          scenarios: [],
          reason: null
        });
        return;
      }
      var cancelled = false;
      setRestricted({
        phase: 'loading',
        scenarios: [],
        reason: null
      });
      (window.loadRestrictedScenarios ? window.loadRestrictedScenarios(heldCourses) : Promise.resolve({
        ok: false,
        reason: 'unavailable',
        scenarios: []
      })).then(function (res) {
        if (cancelled) return;
        setRestricted({
          // Entitled but the read failed (offline, rules not published): say so, not a blank list.
          phase: res.ok ? res.scenarios.length ? 'ready' : 'empty' : 'error',
          scenarios: res.scenarios,
          reason: res.reason
        });
      });
      return function () {
        cancelled = true;
      };
      // Read again each time the section is opened, so a course just uploaded shows up.
    }, [heldKey, !!(premadeCategory && premadeCategory.restricted)]);
    var RestrictedSection = function RestrictedSection() {
      var signedIn = !!(auth && auth.phase === 'signedIn');
      var status = auth && auth.profile && auth.profile.status || null;
      var CourseAccessList = window.CourseAccessList || null;
      var missingCourses = (window.COURSE_ACCESS || []).filter(function (c) {
        return !heldCourses.includes(c.key);
      });
      // ITEM 5: the same modal the header's account button opens. Read off window so this screen
      // keeps working if data/auth.js never loaded (the no-accounts deployment).
      var AuthModalComponent = window.AuthModal || null;
      return /*#__PURE__*/React.createElement("div", {
        className: "space-y-3"
      }, /*#__PURE__*/React.createElement("div", {
        className: "flex items-center gap-2 mb-2"
      }, /*#__PURE__*/React.createElement(Button, {
        variant: "secondary",
        onClick: function onClick() {
          return setPremadeCategory(null);
        },
        className: "h-8 px-2 text-xs"
      }, /*#__PURE__*/React.createElement(Lucide, {
        icon: "arrow-left"
      }), " Back"), /*#__PURE__*/React.createElement("h3", {
        className: "text-lg font-bold text-amber-400 flex items-center gap-2"
      }, /*#__PURE__*/React.createElement(Lucide, {
        icon: restrictedUnlocked ? 'unlock' : 'lock',
        className: "w-4 h-4"
      }), " Course scenarios")), restrictedUnlocked && missingCourses.length > 0 && CourseAccessList && /*#__PURE__*/React.createElement("div", {
        className: "bg-slate-900 border border-slate-700 rounded-lg p-3 space-y-2",
        "data-testid": "course-access-more"
      }, /*#__PURE__*/React.createElement("p", {
        className: "text-xs text-slate-400"
      }, "Each course is approved separately. You can see ", heldCourses.map(function (k) {
        return ((window.COURSE_ACCESS || []).find(function (c) {
          return c.key === k;
        }) || {
          "short": k
        })["short"];
      }).join(' and '), "."), /*#__PURE__*/React.createElement(CourseAccessList, {
        auth: auth,
        compact: true
      }), auth.notice && /*#__PURE__*/React.createElement("div", {
        className: "text-xs text-emerald-300"
      }, auth.notice), auth.error && /*#__PURE__*/React.createElement("div", {
        className: "text-xs text-red-300"
      }, auth.error)), !restrictedUnlocked ? /*#__PURE__*/React.createElement("div", {
        className: "bg-slate-900 border border-amber-700/60 rounded-lg p-4 space-y-3"
      }, /*#__PURE__*/React.createElement("div", {
        className: "flex items-start gap-3"
      }, /*#__PURE__*/React.createElement(Lucide, {
        icon: "lock",
        className: "w-6 h-6 text-amber-400 flex-none mt-0.5"
      }), /*#__PURE__*/React.createElement("div", {
        className: "text-sm text-slate-300 space-y-2"
      }, /*#__PURE__*/React.createElement("p", {
        className: "font-bold text-amber-300"
      }, "This section is locked."), /*#__PURE__*/React.createElement("p", null, "It holds scenarios from specific courses (for example ALS, ETC, CABC and others). They are copyrighted, so they cannot be distributed with the app and are only released to approved course faculty and participants."), /*#__PURE__*/React.createElement("p", {
        className: "text-slate-400"
      }, "Everything else in the simulator \u2014 all ", ALL_SCENARIOS.length, " built-in scenarios, Quick Sim, the monitor, the defibrillator and the debrief \u2014 needs no account at all."))), /*#__PURE__*/React.createElement("div", {
        className: "border-t border-slate-800 pt-3 text-xs space-y-2"
      }, !auth || !auth.available ? /*#__PURE__*/React.createElement("p", {
        className: "text-slate-400"
      }, "Accounts are not switched on for this deployment yet, so there is nothing to sign in to. Nothing is broken \u2014 this section will unlock once the owner enables it.") : !signedIn ?
      /*#__PURE__*/
      /* SIGNED OUT. Exactly one control is offered and it is right here; the
         request-access button is described as appearing AFTER sign-in, which
         is what actually happens. */
      React.createElement("div", {
        className: "space-y-2"
      }, /*#__PURE__*/React.createElement("p", {
        className: "text-slate-400"
      }, "You are not signed in. Sign in first \u2014 the ", /*#__PURE__*/React.createElement("b", null, "Request access"), " button appears here once you are, and access is then granted by the owner."), /*#__PURE__*/React.createElement(Button, {
        onClick: function onClick() {
          return setRestrictedAuthOpen(true);
        },
        variant: "outline",
        className: "h-8 px-3 text-xs text-sky-300 border-sky-500/60"
      }, /*#__PURE__*/React.createElement(Lucide, {
        icon: "log-in",
        className: "w-3 h-3 mr-1"
      }), " Sign in or create an account"), /*#__PURE__*/React.createElement("p", {
        className: "text-slate-400"
      }, "The account button in the header does the same thing."), AuthModalComponent && restrictedAuthOpen && /*#__PURE__*/React.createElement(AuthModalComponent, {
        auth: auth,
        onClose: function onClose() {
          if (auth.clearFeedback) auth.clearFeedback();
          setRestrictedAuthOpen(false);
        },
        context: "Sign in, then request access to course scenarios."
      })) : /*#__PURE__*/React.createElement("div", {
        className: "space-y-2"
      }, /*#__PURE__*/React.createElement("p", {
        className: "text-slate-400"
      }, "Signed in as ", /*#__PURE__*/React.createElement("span", {
        className: "text-slate-200 font-bold"
      }, auth.user && auth.user.email), ".", status === 'rejected' ? ' Your access request was not approved.' : ' Each course is approved separately. If you teach or attend one, request access to it below (also available from your account, top right).'), CourseAccessList && /*#__PURE__*/React.createElement(CourseAccessList, {
        auth: auth,
        compact: true
      }), auth.notice && /*#__PURE__*/React.createElement("div", {
        className: "text-emerald-300"
      }, auth.notice), auth.error && /*#__PURE__*/React.createElement("div", {
        className: "text-red-300"
      }, auth.error)))) : restricted.phase === 'loading' ? /*#__PURE__*/React.createElement("div", {
        className: "text-center text-slate-400 py-8 text-sm"
      }, "Loading course scenarios\u2026") : restricted.phase === 'error' ? /*#__PURE__*/React.createElement("div", {
        className: "bg-slate-900 border border-red-800 rounded-lg p-4 text-sm text-slate-300 space-y-2",
        role: "alert"
      }, /*#__PURE__*/React.createElement("p", {
        className: "font-bold text-red-300"
      }, "Course scenarios could not be loaded."), /*#__PURE__*/React.createElement("p", {
        className: "text-slate-400"
      }, restricted.reason === 'denied' ? 'The database refused the read. If access was granted recently, sign out and in again.' : 'Check the internet connection, then go Back and open Course scenarios again.')) : restricted.phase === 'empty' ? /*#__PURE__*/React.createElement("div", {
        className: "bg-slate-900 border border-slate-700 rounded-lg p-4 text-sm text-slate-300 space-y-2"
      }, /*#__PURE__*/React.createElement("p", {
        className: "font-bold text-emerald-400"
      }, "Unlocked \u2014 but there is nothing here yet."), /*#__PURE__*/React.createElement("p", {
        className: "text-slate-400"
      }, "No scenarios have been added for your course", heldCourses.length > 1 ? 's' : '', " yet. An admin uploads them from Admin, Course scenarios (see the \u201CRestricted scenarios\u201D section of README.md).")) : function () {
        var MS = window.MarkScheme;
        var courseOf = MS ? MS.courseOf : function (x) {
          return x.course || 'Other';
        };
        var courses = Array.from(new Set(restricted.scenarios.map(courseOf)));
        var course = courses.includes(restrictedCourse) ? restrictedCourse : 'All';
        var shown = restricted.scenarios.filter(function (s) {
          return course === 'All' || courseOf(s) === course;
        });
        var groups = MS ? MS.groupScenarios(shown) : [{
          key: '',
          scenarios: shown
        }];
        return /*#__PURE__*/React.createElement("div", {
          className: "space-y-2"
        }, courses.length > 1 && /*#__PURE__*/React.createElement("div", {
          className: "flex flex-wrap gap-1",
          role: "group",
          "aria-label": "Course"
        }, ['All'].concat(courses).map(function (c) {
          return /*#__PURE__*/React.createElement("button", {
            key: c,
            type: "button",
            "aria-pressed": course === c,
            onClick: function onClick() {
              return setRestrictedCourse(c);
            },
            className: "h-8 px-3 rounded border text-xs font-bold ".concat(course === c ? 'bg-amber-700 border-amber-500 text-white' : 'border-slate-600 text-slate-300 hover:text-white')
          }, c === 'All' ? 'All courses' : c);
        })), /*#__PURE__*/React.createElement("p", {
          className: "text-[11px] text-amber-300/80"
        }, "Course material is copyrighted: use it on the course it belongs to, and do not copy or share it."), /*#__PURE__*/React.createElement("div", {
          className: "grid grid-cols-1 gap-2 max-h-[60vh] overflow-y-auto pr-2"
        }, groups.map(function (g) {
          return /*#__PURE__*/React.createElement("div", {
            key: g.key,
            className: "space-y-2"
          }, g.key && groups.length > 1 && /*#__PURE__*/React.createElement("h4", {
            className: "text-xs font-bold uppercase tracking-wider text-amber-400 mt-2"
          }, g.key), g.scenarios.map(function (s) {
            return /*#__PURE__*/React.createElement("div", {
              key: s.id,
              className: "flex flex-wrap gap-2 justify-between items-center bg-amber-950/20 hover:bg-amber-900/20 p-3 rounded border border-amber-800/50 group"
            }, /*#__PURE__*/React.createElement("div", {
              className: "flex-1 min-w-[12rem]"
            }, /*#__PURE__*/React.createElement("div", {
              className: "font-bold text-slate-200 group-hover:text-white flex flex-wrap items-center gap-2"
            }, s.title, /*#__PURE__*/React.createElement("span", {
              className: "text-[9px] bg-emerald-900/40 text-emerald-300 px-1 rounded border border-emerald-700 uppercase font-bold",
              "data-testid": "course-badge"
            }, s.course && String(s.course).trim() || ((window.COURSE_ACCESS || []).find(function (c) {
              return c.key === s.courseKey;
            }) || {
              "short": 'Course'
            })["short"]), /*#__PURE__*/React.createElement(DiffBadge, {
              d: s.difficulty
            })), /*#__PURE__*/React.createElement("div", {
              className: "text-xs text-slate-400 truncate"
            }, getScenarioPreviewText(s))), /*#__PURE__*/React.createElement("div", {
              className: "flex gap-2 flex-none"
            }, window.MarkScheme && window.MarkScheme.get(s) && /*#__PURE__*/React.createElement(Button, {
              onClick: function onClick() {
                return setMarkSheetFor(s);
              },
              variant: "outline",
              className: "h-8 text-xs px-3"
            }, "Mark sheet"), /*#__PURE__*/React.createElement(Button, {
              onClick: function onClick() {
                return loadIntoBuilder(s);
              },
              variant: "secondary",
              className: "h-8 text-xs px-3"
            }, "Edit"), /*#__PURE__*/React.createElement(Button, {
              onClick: function onClick() {
                return handleGenerate(s);
              },
              variant: "primary",
              className: "h-8 text-xs px-3"
            }, "Load")));
          }));
        })), markSheetFor && window.MarkScheme && /*#__PURE__*/React.createElement(window.MarkScheme.MarkSheetModal, {
          scenario: markSheetFor,
          onClose: function onClose() {
            return setMarkSheetFor(null);
          }
        }));
      }());
    };
    var premadeCategories = [{
      id: 'Medical',
      label: 'Adult Medical',
      icon: 'stethoscope',
      filter: function filter(s) {
        return s.category === 'Medical' && s.ageRange === 'Adult';
      }
    }, {
      id: 'Trauma',
      label: 'Trauma',
      icon: 'ambulance',
      filter: function filter(s) {
        return s.category === 'Trauma';
      }
    }, {
      id: 'Paediatric',
      label: 'Paediatric',
      icon: 'baby',
      filter: function filter(s) {
        return s.ageRange === 'Paediatric';
      }
    }, {
      id: 'Resus',
      label: 'Cardiac Arrest',
      icon: 'heart-pulse',
      filter: function filter(s) {
        return s.category === 'Cardiac Arrest';
      }
    }, {
      id: 'Toxicology',
      label: 'Toxicology',
      icon: 'skull',
      filter: function filter(s) {
        return s.category === 'Toxicology';
      }
    }, {
      id: 'ObsGyn',
      label: 'Obs & Gynae',
      icon: 'baby',
      filter: function filter(s) {
        return s.category === 'Obstetrics & Gynae';
      }
    }, {
      id: 'Elderly',
      label: 'Geriatrics',
      icon: 'user',
      filter: function filter(s) {
        return s.ageRange === 'Elderly';
      }
    }, {
      id: 'Psychiatric',
      label: 'Psychiatric',
      icon: 'brain',
      filter: function filter(s) {
        return s.category === 'Psychiatric';
      }
    },
    // The restricted category. `restricted: true` means it does NOT filter
    // ALL_SCENARIOS at all — its contents come from Firebase at runtime, or it shows locked.
    {
      id: 'Restricted',
      label: 'Course scenarios (ALS, ETC, CABC)',
      icon: restrictedUnlocked ? 'unlock' : 'lock',
      restricted: true,
      filter: function filter() {
        return false;
      }
    }];

    // WHAT TO RUN. Six plain choices, nothing preselected; picking one opens its panel. The
    // patient screens are connected whenever they are needed (a collapsed card below), and
    // the WETFLAG option sits only where a child can come up.
    var MODES = [{
      id: 'premade',
      label: 'Scenario library',
      icon: 'book-open',
      text: 'Pick a ready-made case: medical, trauma, paediatric, arrest and more.'
    }, {
      id: 'random',
      label: 'Random scenario',
      icon: 'shuffle',
      text: 'Generate a case from a few filters.'
    }, {
      id: 'quick',
      label: 'Quick Sim',
      icon: 'sliders',
      text: 'A blank patient. You set the obs and the rhythm as you go.'
    }, {
      id: 'vent',
      label: 'Ventilator Sim',
      icon: 'wind',
      text: 'Transport ventilator scenarios, in Education or Assessment mode.'
    }, {
      id: 'icu',
      label: 'Anaesthetics / ICU',
      icon: 'bed',
      text: 'Anaesthetic emergencies for novice anaesthetists on an anaesthetic machine, and ICU ventilation on the ICU ventilator.'
    }, {
      id: 'defib',
      label: 'Defib Sim',
      icon: 'zap',
      text: 'Defibrillator skills on a tablet defib.'
    }, {
      id: 'custom',
      label: 'My scenarios',
      icon: 'folder',
      text: 'Scenarios you have built or imported, and the scenario builder.'
    }];
    var modeGroup = mode === 'builder' ? 'custom' : mode;
    var current = MODES.find(function (m) {
      return m.id === modeGroup;
    });
    var pickMode = function pickMode(m) {
      setMode(m);
      setPremadeCategory(null);
    };
    var wetflagOption = ['premade', 'random', 'custom', 'builder'].includes(mode) && /*#__PURE__*/React.createElement("label", {
      className: "flex items-start gap-2 text-xs text-slate-300 mt-4 pt-3 border-t border-slate-700 cursor-pointer"
    }, /*#__PURE__*/React.createElement("input", {
      type: "checkbox",
      "aria-label": "Show WETFLAG on the monitor",
      checked: showWetflag,
      onChange: function onChange(e) {
        return setShowWetflag(e.target.checked);
      },
      className: "mt-0.5 w-4 h-4 rounded border-slate-500 text-sky-500 focus:ring-sky-500"
    }), /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("b", {
      className: "text-white"
    }, "Show WETFLAG on the monitor from the start"), " (paediatric scenarios). Off by default; you can show or hide it at any time from Rhythm & resus."));
    return /*#__PURE__*/React.createElement("div", {
      className: "max-w-4xl mx-auto p-4 h-full overflow-y-auto space-y-5"
    }, savedState && /*#__PURE__*/React.createElement("div", {
      className: "bg-emerald-900/30 border border-emerald-500 p-4 rounded-lg flex items-center justify-between gap-3 animate-fadeIn"
    }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h3", {
      className: "font-bold text-emerald-400"
    }, savedState.live ? 'Scenario paused' : 'Resume Previous?'), /*#__PURE__*/React.createElement("p", {
      className: "text-sm text-slate-300"
    }, savedState.scenario && savedState.scenario.title || 'Saved session', savedState.live ? ' is paused where you left it. Return to it, or choose something new below.' : '')), /*#__PURE__*/React.createElement(Button, {
      onClick: onResume,
      variant: "success",
      className: "flex-none"
    }, savedState.live ? 'Return to scenario' : 'Resume')), !mode ? /*#__PURE__*/React.createElement("section", {
      "aria-labelledby": "run-heading",
      "data-testid": "mode-chooser"
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex flex-wrap items-center gap-3 mb-3"
    }, onStartScreen && /*#__PURE__*/React.createElement(Button, {
      variant: "secondary",
      onClick: onStartScreen,
      ariaLabel: "Back to the start screen",
      className: "h-9 px-3 text-sm"
    }, /*#__PURE__*/React.createElement(Lucide, {
      icon: "arrow-left",
      className: "w-4 h-4"
    }), " Start screen"), /*#__PURE__*/React.createElement("h2", {
      id: "run-heading",
      className: "text-xl font-bold text-white"
    }, "What do you want to run?")), /*#__PURE__*/React.createElement("div", {
      className: "grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3"
    }, MODES.map(function (m) {
      return /*#__PURE__*/React.createElement("button", {
        key: m.id,
        type: "button",
        onClick: function onClick() {
          return pickMode(m.id);
        },
        "aria-label": m.label,
        "data-testid": "mode-".concat(m.id),
        className: "text-left flex flex-col items-start justify-start rounded-lg border-2 border-slate-600 bg-slate-800 hover:border-sky-400 hover:bg-slate-700/60 p-4 transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-sky-400"
      }, /*#__PURE__*/React.createElement(Lucide, {
        icon: m.icon,
        className: "w-6 h-6 text-sky-300 mb-2"
      }), /*#__PURE__*/React.createElement("div", {
        className: "font-bold text-white"
      }, m.label), /*#__PURE__*/React.createElement("div", {
        className: "text-xs text-slate-300 mt-1 leading-snug"
      }, m.text));
    }))) : /*#__PURE__*/React.createElement("div", {
      className: "bg-slate-800 p-4 sm:p-6 rounded-lg border border-slate-700 shadow-xl"
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex flex-wrap items-center gap-3 mb-5 pb-3 border-b border-slate-700"
    }, /*#__PURE__*/React.createElement(Button, {
      variant: "secondary",
      onClick: function onClick() {
        return pickMode(null);
      },
      className: "h-9 px-3 text-sm"
    }, /*#__PURE__*/React.createElement(Lucide, {
      icon: "arrow-left",
      className: "w-4 h-4"
    }), " All options"), /*#__PURE__*/React.createElement("h2", {
      className: "text-lg font-bold text-white flex items-center gap-2"
    }, current && /*#__PURE__*/React.createElement(Lucide, {
      icon: current.icon,
      className: "w-5 h-5 text-sky-300"
    }), current ? current.label : ''), modeGroup === 'custom' && /*#__PURE__*/React.createElement("div", {
      className: "flex gap-1 ml-auto",
      role: "group",
      "aria-label": "My scenarios"
    }, /*#__PURE__*/React.createElement("button", {
      type: "button",
      onClick: function onClick() {
        return setMode('custom');
      },
      "aria-pressed": mode === 'custom',
      className: "px-3 h-8 rounded text-xs font-bold ".concat(mode === 'custom' ? 'bg-sky-700 text-white' : 'bg-slate-700 text-slate-300 hover:text-white')
    }, "Saved"), /*#__PURE__*/React.createElement("button", {
      type: "button",
      onClick: function onClick() {
        return setMode('builder');
      },
      "aria-pressed": mode === 'builder',
      className: "px-3 h-8 rounded text-xs font-bold ".concat(mode === 'builder' ? 'bg-sky-700 text-white' : 'bg-slate-700 text-slate-300 hover:text-white')
    }, "Builder"))), mode === 'quick' && /*#__PURE__*/React.createElement("div", {
      className: "space-y-4 animate-fadeIn"
    }, /*#__PURE__*/React.createElement("div", {
      className: "bg-sky-950/30 border border-sky-700/50 rounded p-3 text-sm text-slate-300"
    }, /*#__PURE__*/React.createElement("p", {
      className: "font-bold text-sky-300 mb-1 flex items-center gap-2"
    }, /*#__PURE__*/React.createElement(Lucide, {
      icon: "sliders",
      className: "w-4 h-4"
    }), " Quick Sim \u2014 obs and rhythm only"), /*#__PURE__*/React.createElement("p", {
      className: "text-xs text-slate-400"
    }, "A blank patient with editable observations, the full rhythm list, arrest/ROSC, the defibrillator and the monitor. No scenario brief, no drug library, no learning objectives. You still get the timer, the event log and a debrief.")), /*#__PURE__*/React.createElement("div", {
      className: "grid grid-cols-2 md:grid-cols-4 gap-2"
    }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("label", {
      className: "text-[10px] text-slate-400 uppercase"
    }, "Age (years)"), /*#__PURE__*/React.createElement("input", {
      "aria-label": "Age (years)",
      type: "number",
      min: BUILDER_LIMITS.age.min,
      max: BUILDER_LIMITS.age.max,
      value: qsAge,
      onChange: function onChange(e) {
        return setQsAge(e.target.value);
      },
      placeholder: "40",
      className: fieldClass(qsAgeError)
    }), /*#__PURE__*/React.createElement(FieldError, {
      msg: qsAgeError
    })), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("label", {
      className: "text-[10px] text-slate-400 uppercase"
    }, "Weight (kg)"), /*#__PURE__*/React.createElement("input", {
      "aria-label": "Weight (kg)",
      type: "number",
      min: BUILDER_LIMITS.weight.min,
      max: BUILDER_LIMITS.weight.max,
      step: "0.1",
      value: qsWeight,
      onChange: function onChange(e) {
        return setQsWeight(e.target.value);
      },
      placeholder: qsAutoWeight ? "auto ".concat(qsAutoWeight) : 'optional',
      className: fieldClass(qsWeightError)
    }), /*#__PURE__*/React.createElement(FieldError, {
      msg: qsWeightError
    })), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("label", {
      className: "text-[10px] text-slate-400 uppercase"
    }, "Sex"), /*#__PURE__*/React.createElement("select", {
      "aria-label": "Sex",
      value: qsSex,
      onChange: function onChange(e) {
        return setQsSex(e.target.value);
      },
      className: "w-full bg-slate-900 border border-slate-600 rounded p-2 text-white"
    }, /*#__PURE__*/React.createElement("option", null, "Male"), /*#__PURE__*/React.createElement("option", null, "Female"))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("label", {
      className: "text-[10px] text-slate-400 uppercase"
    }, "Name"), /*#__PURE__*/React.createElement("input", {
      "aria-label": "Name",
      type: "text",
      value: qsName,
      onChange: function onChange(e) {
        return setQsName(e.target.value);
      },
      placeholder: "Quick Sim Patient",
      className: "w-full bg-slate-900 border border-slate-600 rounded p-2 text-white placeholder-slate-400"
    }))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("label", {
      className: "text-[10px] text-slate-400 uppercase"
    }, "Starting rhythm"), /*#__PURE__*/React.createElement("select", {
      "aria-label": "Starting rhythm",
      value: qsRhythm,
      onChange: function onChange(e) {
        return setQsRhythm(e.target.value);
      },
      className: "w-full bg-slate-900 border border-slate-600 rounded p-2 text-white"
    }, (window.RHYTHMS ? window.RHYTHMS.SELECTABLE : ['Sinus Rhythm']).map(function (r) {
      return /*#__PURE__*/React.createElement("option", {
        key: r,
        value: r
      }, window.RHYTHMS ? window.RHYTHMS.labelFor(r) : r);
    })), /*#__PURE__*/React.createElement("p", {
      className: "text-[10px] text-slate-400 mt-1"
    }, "Changeable at any time from the controller, including every arrest rhythm.")), qsResolvedAge < 18 && !qsInvalid && function () {
      var w = qsWeight === '' ? qsAutoWeight === null ? null : parseFloat(qsAutoWeight) : Number(qsWeight);
      var wf = w ? calculateWetflag(qsResolvedAge, w) : null;
      if (!wf) return null;
      return /*#__PURE__*/React.createElement("div", {
        className: "p-3 bg-purple-900/20 border border-purple-500/40 rounded"
      }, /*#__PURE__*/React.createElement("h4", {
        className: "text-[10px] font-bold text-purple-300 uppercase tracking-widest mb-1"
      }, "WETFLAG will be active (", wf.weight, " kg)"), /*#__PURE__*/React.createElement("div", {
        className: "text-[11px] text-slate-300"
      }, "Shock energy ", wf.energy, " J \xB7 Tube ", wf.tube, " \xB7 Fluids ", wf.fluids, " ml \xB7 Adrenaline ", wf.adrenaline, " mcg \xB7 Glucose ", wf.glucose, " ml"));
    }(), /*#__PURE__*/React.createElement(Button, {
      onClick: launchQuickSim,
      disabled: qsInvalid,
      className: "w-full py-4 text-lg shadow-lg shadow-sky-900/20 ".concat(qsInvalid ? 'opacity-40 cursor-not-allowed' : '')
    }, "Start Quick Sim"), qsInvalid && /*#__PURE__*/React.createElement("p", {
      className: "text-xs text-red-400 text-center"
    }, "Fix the highlighted fields to start.")), mode === 'defib' && (window.DefibSimSetup ? /*#__PURE__*/React.createElement(window.DefibSimSetup, {
      onStart: function onStart(opts) {
        return onDefibSim ? onDefibSim(opts) : alert('Defib Sim is unavailable in this build.');
      }
    }) : /*#__PURE__*/React.createElement("div", {
      className: "text-sm text-slate-400"
    }, "Defib Sim is unavailable in this build.")), mode === 'vent' && (window.VentSimSetup && window.VentSim ? /*#__PURE__*/React.createElement(window.VentSimSetup, {
      onStart: function onStart(opts) {
        return onVentSim ? onVentSim(opts) : alert('Ventilator Sim is unavailable in this build.');
      }
    }) : /*#__PURE__*/React.createElement("div", {
      className: "text-sm text-slate-400"
    }, "Ventilator Sim is unavailable in this build.")), mode === 'icu' && (window.VentSimSetup && window.VentSim ? /*#__PURE__*/React.createElement(window.VentSimSetup, {
      key: "icu",
      devices: ['a350', 'c6'],
      onStart: function onStart(opts) {
        return onVentSim ? onVentSim(opts) : alert('The anaesthetic machine and ICU ventilator are unavailable in this build.');
      }
    }) : /*#__PURE__*/React.createElement("div", {
      className: "text-sm text-slate-400"
    }, "The anaesthetic machine and ICU ventilator are unavailable in this build.")), mode === 'random' && /*#__PURE__*/React.createElement("div", {
      className: "space-y-4 animate-fadeIn"
    }, /*#__PURE__*/React.createElement("div", {
      className: "grid grid-cols-2 gap-4"
    }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("label", {
      className: "text-xs font-bold text-slate-400"
    }, "Category"), /*#__PURE__*/React.createElement("select", {
      "aria-label": "Category",
      value: category,
      onChange: function onChange(e) {
        return setCategory(e.target.value);
      },
      className: "w-full bg-slate-700 rounded p-2 text-sm text-white border border-slate-600"
    }, /*#__PURE__*/React.createElement("option", {
      value: "Any"
    }, "Any"), /*#__PURE__*/React.createElement("option", {
      value: "Medical"
    }, "Medical"), /*#__PURE__*/React.createElement("option", {
      value: "Trauma"
    }, "Trauma"), /*#__PURE__*/React.createElement("option", {
      value: "Obstetrics & Gynae"
    }, "Obs & Gynae"), /*#__PURE__*/React.createElement("option", {
      value: "Cardiac Arrest"
    }, "Cardiac Arrest"), /*#__PURE__*/React.createElement("option", {
      value: "Toxicology"
    }, "Toxicology"), /*#__PURE__*/React.createElement("option", {
      value: "Psychiatric"
    }, "Psychiatric"))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("label", {
      className: "text-xs font-bold text-slate-400"
    }, "Age"), /*#__PURE__*/React.createElement("select", {
      "aria-label": "Age",
      value: age,
      onChange: function onChange(e) {
        return setAge(e.target.value);
      },
      className: "w-full bg-slate-700 rounded p-2 text-sm text-white border border-slate-600"
    }, /*#__PURE__*/React.createElement("option", {
      value: "Any"
    }, "Any"), /*#__PURE__*/React.createElement("option", {
      value: "Adult"
    }, "Adult"), /*#__PURE__*/React.createElement("option", {
      value: "Paediatric"
    }, "Paediatric"), /*#__PURE__*/React.createElement("option", {
      value: "Elderly"
    }, "Elderly"))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("label", {
      className: "text-xs font-bold text-slate-400"
    }, "Acuity"), /*#__PURE__*/React.createElement("select", {
      "aria-label": "Acuity",
      value: acuity,
      onChange: function onChange(e) {
        return setAcuity(e.target.value);
      },
      className: "w-full bg-slate-700 rounded p-2 text-sm text-white border border-slate-600"
    }, /*#__PURE__*/React.createElement("option", {
      value: "Any"
    }, "Any"), /*#__PURE__*/React.createElement("option", {
      value: "Majors"
    }, "Majors"), /*#__PURE__*/React.createElement("option", {
      value: "Resus"
    }, "Resus"))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("label", {
      className: "text-xs font-bold text-slate-400"
    }, "Human Factors"), /*#__PURE__*/React.createElement("select", {
      "aria-label": "Human Factors",
      value: hf,
      onChange: function onChange(e) {
        return setHf(e.target.value);
      },
      className: "w-full bg-slate-700 rounded p-2 text-sm text-white border border-slate-600"
    }, HUMAN_FACTOR_CHALLENGES.map(function (h) {
      return /*#__PURE__*/React.createElement("option", {
        key: h.id,
        value: h.id
      }, h.type);
    })))), /*#__PURE__*/React.createElement(Button, {
      onClick: function onClick() {
        return handleGenerate(null);
      },
      className: "w-full py-4 text-lg shadow-lg shadow-sky-900/20"
    }, "Generate Scenario")), mode === 'premade' && /*#__PURE__*/React.createElement("div", {
      className: "animate-fadeIn min-h-[300px]"
    }, !premadeCategory ? /*#__PURE__*/React.createElement("div", {
      className: "grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3"
    }, premadeCategories.map(function (cat) {
      return /*#__PURE__*/React.createElement("button", {
        key: cat.id,
        onClick: function onClick() {
          return setPremadeCategory(cat);
        },
        className: "flex flex-col items-center justify-center p-4 border rounded-lg transition-all active:scale-95 group ".concat(cat.restricted ? 'bg-amber-950/30 hover:bg-amber-900/30 border-amber-700/60' : 'bg-slate-700 hover:bg-slate-600 border-slate-600')
      }, /*#__PURE__*/React.createElement(Lucide, {
        icon: cat.restricted && !restrictedUnlocked ? 'lock' : cat.icon,
        className: "w-8 h-8 mb-2 ".concat(cat.restricted ? 'text-amber-400' : 'text-sky-400 group-hover:text-white')
      }), /*#__PURE__*/React.createElement("span", {
        className: "text-sm font-bold text-slate-200 group-hover:text-white text-center leading-tight"
      }, cat.label), cat.restricted && /*#__PURE__*/React.createElement("span", {
        className: "text-[9px] uppercase tracking-wider font-bold text-amber-500/80 mt-1"
      }, restrictedUnlocked ? 'unlocked' : 'locked'));
    })) : premadeCategory.restricted ?
    // Called, not mounted: a component defined inside SetupScreen is a new type on every
    // render, so the panel (and its sign-in box) was rebuilt, losing what was typed.
    RestrictedSection() : /*#__PURE__*/React.createElement("div", {
      className: "space-y-3"
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex items-center gap-2 mb-4"
    }, /*#__PURE__*/React.createElement(Button, {
      variant: "secondary",
      onClick: function onClick() {
        return setPremadeCategory(null);
      },
      className: "h-8 px-2 text-xs"
    }, /*#__PURE__*/React.createElement(Lucide, {
      icon: "arrow-left"
    }), " Back"), /*#__PURE__*/React.createElement("h3", {
      className: "text-lg font-bold text-sky-400"
    }, premadeCategory.label, " Scenarios")), /*#__PURE__*/React.createElement("div", {
      className: "grid grid-cols-1 gap-2 max-h-[400px] overflow-y-auto pr-2",
      "data-testid": "library-list"
    }, ALL_SCENARIOS.filter(premadeCategory.filter).map(function (s) {
      return /*#__PURE__*/React.createElement("div", {
        key: s.id,
        className: "flex flex-wrap gap-2 justify-between items-center bg-slate-700/40 hover:bg-slate-700 p-3 rounded border border-slate-600 group"
      }, /*#__PURE__*/React.createElement("div", {
        className: "flex-1 min-w-[12rem]"
      }, /*#__PURE__*/React.createElement("div", {
        className: "font-bold text-slate-200 group-hover:text-white flex flex-wrap items-center gap-2"
      }, s.title, " ", s.acuity === 'Resus' && /*#__PURE__*/React.createElement("span", {
        className: "text-[9px] bg-red-900/50 text-red-400 px-1 rounded border border-red-800"
      }, "RESUS"), " ", /*#__PURE__*/React.createElement(DiffBadge, {
        d: s.difficulty
      })), /*#__PURE__*/React.createElement("div", {
        className: "text-xs text-slate-400"
      }, function (t) {
        return t.length > 60 ? t.substring(0, 60) + '…' : t;
      }(getScenarioPreviewText(s)))), /*#__PURE__*/React.createElement("div", {
        className: "flex gap-2 flex-none ml-auto"
      }, /*#__PURE__*/React.createElement(Button, {
        onClick: function onClick() {
          return loadIntoBuilder(s);
        },
        variant: "secondary",
        className: "h-8 text-xs px-3"
      }, "Edit"), /*#__PURE__*/React.createElement(Button, {
        onClick: function onClick() {
          return handleGenerate(s);
        },
        variant: "primary",
        className: "h-8 text-xs px-3"
      }, "Load")));
    }), ALL_SCENARIOS.filter(premadeCategory.filter).length === 0 && /*#__PURE__*/React.createElement("div", {
      className: "text-center text-slate-400 py-8"
    }, "No scenarios found in this category.")))), mode === 'custom' && /*#__PURE__*/React.createElement("div", {
      className: "space-y-2 animate-fadeIn",
      "data-testid": "my-scenarios"
    }, myNotice && /*#__PURE__*/React.createElement("div", {
      role: "status",
      className: "text-xs bg-emerald-950/50 border border-emerald-700 rounded p-2 text-emerald-200"
    }, myNotice), !accountsOn ? /*#__PURE__*/React.createElement("p", {
      className: "text-xs text-slate-400 bg-slate-900 border border-slate-700 rounded p-3"
    }, "Accounts are not available right now, so scenarios cannot be saved. You can still write one in ", /*#__PURE__*/React.createElement("b", null, "Builder"), " and run it without saving.") : !uid ? /*#__PURE__*/React.createElement("div", {
      className: "bg-slate-900 border border-sky-800/60 rounded p-3 text-sm text-slate-300 space-y-2"
    }, /*#__PURE__*/React.createElement("p", null, auth.phase === 'checking' ? 'Checking your account…' : 'Sign in to save your own scenarios to your account and use them on any device.'), auth.phase !== 'checking' && /*#__PURE__*/React.createElement(Button, {
      onClick: function onClick() {
        return setMyAuthOpen(true);
      },
      variant: "outline",
      className: "h-8 px-3 text-xs text-sky-300 border-sky-500/60"
    }, /*#__PURE__*/React.createElement(Lucide, {
      icon: "log-in",
      className: "w-3 h-3 mr-1"
    }), " Sign in or create an account"), /*#__PURE__*/React.createElement("p", {
      className: "text-xs text-slate-400"
    }, "Without an account you can still write a scenario in ", /*#__PURE__*/React.createElement("b", null, "Builder"), " and run it, but it is not kept.")) : /*#__PURE__*/React.createElement("div", {
      className: "flex flex-wrap items-center gap-2 pb-2 border-b border-slate-700"
    }, /*#__PURE__*/React.createElement("span", {
      className: "text-xs text-slate-400 mr-auto"
    }, "Saved to ", /*#__PURE__*/React.createElement("span", {
      className: "text-slate-200 font-bold"
    }, auth.user.email || 'your account')), /*#__PURE__*/React.createElement(Button, {
      onClick: exportCustomScenarios,
      variant: "secondary",
      className: "h-8 text-xs flex items-center gap-1"
    }, /*#__PURE__*/React.createElement(Lucide, {
      icon: "download",
      className: "w-3 h-3"
    }), " Export JSON"), /*#__PURE__*/React.createElement("label", {
      className: "cursor-pointer flex items-center"
    }, /*#__PURE__*/React.createElement("span", {
      className: "inline-flex items-center gap-1 px-3 h-8 bg-slate-700 hover:bg-slate-600 border border-slate-600 rounded text-xs text-slate-200 font-bold"
    }, /*#__PURE__*/React.createElement(Lucide, {
      icon: "upload",
      className: "w-3 h-3"
    }), " Import JSON"), /*#__PURE__*/React.createElement("input", {
      type: "file",
      accept: ".json",
      onChange: importCustomScenariosFile,
      className: "hidden",
      "aria-label": "Import scenarios from a JSON file",
      disabled: !canSave
    }))), uid && myStatus === 'loading' && /*#__PURE__*/React.createElement("p", {
      className: "text-slate-400 text-sm text-center py-4"
    }, "Loading your scenarios\u2026"), uid && (myStatus === 'denied' || myStatus === 'unavailable') && /*#__PURE__*/React.createElement("p", {
      className: "text-xs text-red-300 bg-red-950/40 border border-red-700 rounded p-3"
    }, "Your saved scenarios could not be loaded", myStatus === 'denied' ? ' (the database refused access)' : '', ". Check the connection and reload. Scenarios cannot be saved until this works."), canSave && customScenarios.length === 0 && /*#__PURE__*/React.createElement("p", {
      className: "text-slate-400 text-sm italic text-center py-4"
    }, "No saved scenarios yet. Use ", /*#__PURE__*/React.createElement("b", null, "Builder"), " (top right) to make one, or import a file."), canSave && customScenarios.map(function (s) {
      return /*#__PURE__*/React.createElement("div", {
        key: s.id,
        className: "flex flex-wrap gap-2 justify-between items-center bg-slate-700/50 p-3 rounded border border-slate-600"
      }, /*#__PURE__*/React.createElement("div", {
        className: "flex-1 min-w-[12rem]"
      }, /*#__PURE__*/React.createElement("div", {
        className: "font-bold text-white flex flex-wrap items-center gap-2"
      }, s.title, " ", /*#__PURE__*/React.createElement(DiffBadge, {
        d: s.difficulty
      })), /*#__PURE__*/React.createElement("div", {
        className: "text-xs text-slate-400"
      }, getScenarioPreviewText(s))), /*#__PURE__*/React.createElement("div", {
        className: "flex gap-2 flex-none ml-auto"
      }, /*#__PURE__*/React.createElement(Button, {
        onClick: function onClick() {
          return loadIntoBuilder(s);
        },
        variant: "secondary",
        className: "h-8 text-xs"
      }, "Edit"), /*#__PURE__*/React.createElement(Button, {
        onClick: function onClick() {
          return handleGenerate(s);
        },
        variant: "success",
        className: "h-8 text-xs"
      }, "Load"), /*#__PURE__*/React.createElement(Button, {
        onClick: function onClick() {
          if (!window.confirm("Delete \"".concat(s.title, "\" from your account? This cannot be undone."))) return;
          US.remove(uid, s.id)["catch"](function (e) {
            return alert('Could not delete it: ' + (e && e.message || 'the database refused it') + '.');
          });
        },
        variant: "danger",
        className: "h-8 text-xs",
        ariaLabel: "Delete ".concat(s.title)
      }, "Delete")));
    }), legacyScenarios.length > 0 && /*#__PURE__*/React.createElement("div", {
      className: "mt-3 bg-amber-950/30 border border-amber-700/60 rounded p-3 space-y-2",
      "data-testid": "device-scenarios"
    }, /*#__PURE__*/React.createElement("p", {
      className: "text-sm text-amber-200 font-bold"
    }, legacyScenarios.length, " scenario(s) saved on this device only"), /*#__PURE__*/React.createElement("p", {
      className: "text-xs text-slate-300"
    }, canSave ? 'These were saved in this browser before scenarios were kept in accounts. Add them to your account to keep them and use them on other devices.' : 'These were saved in this browser before scenarios were kept in accounts. Sign in to add them to your account; until then you can still run them here.'), canSave ? /*#__PURE__*/React.createElement("div", {
      className: "flex flex-wrap gap-2"
    }, /*#__PURE__*/React.createElement(Button, {
      onClick: addLegacyToAccount,
      variant: "primary",
      className: "h-8 text-xs"
    }, "Add to my account"), /*#__PURE__*/React.createElement(Button, {
      onClick: discardLegacy,
      variant: "outline",
      className: "h-8 text-xs"
    }, "Remove from this device")) : /*#__PURE__*/React.createElement("div", {
      className: "space-y-1"
    }, legacyScenarios.map(function (s) {
      return /*#__PURE__*/React.createElement("div", {
        key: s.id,
        className: "flex justify-between items-center gap-2 bg-slate-800/60 p-2 rounded border border-slate-700"
      }, /*#__PURE__*/React.createElement("div", {
        className: "text-sm text-white font-bold"
      }, s.title), /*#__PURE__*/React.createElement(Button, {
        onClick: function onClick() {
          return handleGenerate(s);
        },
        variant: "success",
        className: "h-8 text-xs"
      }, "Load"));
    }), /*#__PURE__*/React.createElement(Button, {
      onClick: exportCustomScenarios,
      variant: "secondary",
      className: "h-8 text-xs flex items-center gap-1 mt-1"
    }, /*#__PURE__*/React.createElement(Lucide, {
      icon: "download",
      className: "w-3 h-3"
    }), " Export them as a file")))), mode === 'builder' && /*#__PURE__*/React.createElement("div", {
      className: "space-y-4 animate-fadeIn"
    }, buildId && customScenarios.some(function (c) {
      return c.id === buildId;
    }) && /*#__PURE__*/React.createElement("div", {
      className: "flex flex-wrap items-center justify-between gap-2 bg-sky-950/40 border border-sky-800 rounded p-2 text-xs text-sky-200",
      "data-testid": "builder-editing"
    }, /*#__PURE__*/React.createElement("span", null, "Editing your saved scenario. Saving updates it."), /*#__PURE__*/React.createElement(Button, {
      variant: "secondary",
      onClick: newBuilder,
      className: "h-8 px-3 text-xs"
    }, "New scenario")), /*#__PURE__*/React.createElement("input", {
      type: "text",
      placeholder: "Scenario Title",
      value: buildTitle,
      onChange: function onChange(e) {
        return setBuildTitle(e.target.value);
      },
      className: "w-full bg-slate-900 border border-slate-600 rounded p-3 text-white placeholder-slate-400 font-bold"
    }), /*#__PURE__*/React.createElement("div", {
      className: "grid grid-cols-2 md:grid-cols-4 gap-2"
    }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("label", {
      className: "text-[10px] text-slate-400 uppercase"
    }, "Patient Name"), /*#__PURE__*/React.createElement("input", {
      "aria-label": "Patient Name",
      type: "text",
      placeholder: "Auto-generate if blank",
      value: buildName,
      onChange: function onChange(e) {
        return setBuildName(e.target.value);
      },
      className: "w-full bg-slate-900 border border-slate-600 rounded p-2 text-white placeholder-slate-400"
    })), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("label", {
      className: "text-[10px] text-slate-400 uppercase"
    }, "Age"), /*#__PURE__*/React.createElement("input", {
      "aria-label": "Age",
      type: "number",
      min: BUILDER_LIMITS.age.min,
      max: BUILDER_LIMITS.age.max,
      placeholder: "Age",
      value: buildAge,
      onChange: function onChange(e) {
        return setBuildAge(e.target.value);
      },
      className: fieldClass(builderErrors.age)
    }), /*#__PURE__*/React.createElement(FieldError, {
      msg: builderErrors.age
    })), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("label", {
      className: "text-[10px] text-slate-400 uppercase"
    }, "Sex"), /*#__PURE__*/React.createElement("select", {
      "aria-label": "Sex",
      value: buildSex,
      onChange: function onChange(e) {
        return setBuildSex(e.target.value);
      },
      className: "w-full bg-slate-900 border border-slate-600 rounded p-2 text-white"
    }, /*#__PURE__*/React.createElement("option", null, "Male"), /*#__PURE__*/React.createElement("option", null, "Female"))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("label", {
      className: "text-[10px] text-slate-400 uppercase"
    }, "Category"), /*#__PURE__*/React.createElement("select", {
      "aria-label": "Category",
      value: buildCat,
      onChange: function onChange(e) {
        return setBuildCat(e.target.value);
      },
      className: "w-full bg-slate-900 border border-slate-600 rounded p-2 text-white"
    }, /*#__PURE__*/React.createElement("option", null, "Medical"), /*#__PURE__*/React.createElement("option", null, "Trauma"), /*#__PURE__*/React.createElement("option", null, "Cardiac Arrest"), /*#__PURE__*/React.createElement("option", null, "Toxicology"), /*#__PURE__*/React.createElement("option", null, "Obstetrics & Gynae"), /*#__PURE__*/React.createElement("option", null, "Psychiatric"), /*#__PURE__*/React.createElement("option", null, "Paediatric")))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("textarea", {
      placeholder: "Description",
      value: buildDesc,
      onChange: function onChange(e) {
        setDescDirty(true);
        setBuildDesc(e.target.value);
      },
      className: "w-full bg-slate-900 border rounded p-2 text-white h-20 placeholder-slate-400 ".concat(descStale ? 'border-amber-500' : 'border-slate-600')
    }), descStale ? /*#__PURE__*/React.createElement("div", {
      className: "flex items-center justify-between gap-2 text-[11px] text-amber-400 mt-1"
    }, /*#__PURE__*/React.createElement("span", null, "This brief may be out of date \u2014 it does not mention age ", buildAge, "."), /*#__PURE__*/React.createElement("button", {
      type: "button",
      onClick: function onClick() {
        setDescDirty(false);
        setBuildDesc(autoDesc(buildAge, buildSex, buildTitle));
      },
      className: "underline font-bold whitespace-nowrap"
    }, "Regenerate")) : !descDirty && /*#__PURE__*/React.createElement("div", {
      className: "text-[10px] text-slate-400 mt-1"
    }, "Auto-generated from age, sex and title. Editing it stops auto-updates.")), /*#__PURE__*/React.createElement("input", {
      type: "text",
      placeholder: "PMH (comma separated)",
      value: buildPMH,
      onChange: function onChange(e) {
        return setBuildPMH(e.target.value);
      },
      className: "w-full bg-slate-900 border border-slate-600 rounded p-2 text-white text-sm placeholder-slate-400"
    }), /*#__PURE__*/React.createElement("input", {
      type: "text",
      placeholder: "Drug History (comma separated)",
      value: buildDhx,
      onChange: function onChange(e) {
        return setBuildDhx(e.target.value);
      },
      className: "w-full bg-slate-900 border border-slate-600 rounded p-2 text-white text-sm placeholder-slate-400"
    }), /*#__PURE__*/React.createElement("input", {
      type: "text",
      placeholder: "Allergies (comma separated)",
      value: buildAllergies,
      onChange: function onChange(e) {
        return setBuildAllergies(e.target.value);
      },
      className: "w-full bg-slate-900 border border-slate-600 rounded p-2 text-white text-sm placeholder-slate-400"
    }), /*#__PURE__*/React.createElement("div", {
      className: "grid grid-cols-2 gap-2"
    }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("label", {
      className: "text-[10px] text-slate-400 uppercase"
    }, "Difficulty"), /*#__PURE__*/React.createElement("select", {
      "aria-label": "Difficulty",
      value: buildDifficulty,
      onChange: function onChange(e) {
        return setBuildDifficulty(e.target.value);
      },
      className: "w-full bg-slate-900 border border-slate-600 rounded p-2 text-white"
    }, /*#__PURE__*/React.createElement("option", null, "Beginner"), /*#__PURE__*/React.createElement("option", null, "Intermediate"), /*#__PURE__*/React.createElement("option", null, "Advanced"))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("label", {
      className: "text-[10px] text-slate-400 uppercase"
    }, "Learning Objectives (comma separated)"), /*#__PURE__*/React.createElement("input", {
      "aria-label": "Learning Objectives (comma separated)",
      type: "text",
      placeholder: "e.g. Give adrenaline, Secure airway",
      value: buildLearningObj,
      onChange: function onChange(e) {
        return setBuildLearningObj(e.target.value);
      },
      className: "w-full bg-slate-900 border border-slate-600 rounded p-2 text-white text-sm placeholder-slate-400"
    }))), /*#__PURE__*/React.createElement("input", {
      type: "text",
      placeholder: "Custom Scenario Actions (comma separated, e.g. Call Cardiology, Request MRI)",
      value: buildCustomActions,
      onChange: function onChange(e) {
        return setBuildCustomActions(e.target.value);
      },
      className: "w-full bg-slate-900 border border-slate-600 rounded p-2 text-white text-sm placeholder-slate-400"
    }), /*#__PURE__*/React.createElement("div", {
      className: "grid grid-cols-2 gap-2"
    }, /*#__PURE__*/React.createElement("input", {
      type: "url",
      placeholder: "Chest X-ray Image URL (optional)",
      value: buildCxrUrl,
      onChange: function onChange(e) {
        return setBuildCxrUrl(e.target.value);
      },
      className: "w-full bg-slate-900 border border-slate-600 rounded p-2 text-white text-sm placeholder-slate-400"
    }), /*#__PURE__*/React.createElement("input", {
      type: "url",
      placeholder: "CT Scan Image URL (optional)",
      value: buildCtUrl,
      onChange: function onChange(e) {
        return setBuildCtUrl(e.target.value);
      },
      className: "w-full bg-slate-900 border border-slate-600 rounded p-2 text-white text-sm placeholder-slate-400"
    })), window.InvResults && window.INVESTIGATIONS && function () {
      var I = window.INVESTIGATIONS,
        IR = window.InvResults;
      var rowFor = function rowFor(type) {
        var spec = buildInvResults[type];
        if (!spec) return {
          type: type,
          text: 'Default for this scenario.',
          image: null,
          changed: false
        };
        return Object.assign({
          type: type
        }, I.currentResult(I.setResult({
          ecg: {
            type: buildVitals.rhythm || 'Sinus Rhythm'
          }
        }, type, spec), type, buildVitals.rhythm || 'Sinus Rhythm'));
      };
      var setSpec = function setSpec(type, spec) {
        setBuildInvResults(function (prev) {
          var next = Object.assign({}, prev);
          if (spec) next[type] = spec;else delete next[type];
          return next;
        });
        setBuildInvEditing(null);
      };
      var rows = I.RESULT_TYPES.map(rowFor);
      var editing = buildInvEditing ? rows.filter(function (r) {
        return r.type === buildInvEditing;
      })[0] : null;
      return /*#__PURE__*/React.createElement("div", {
        "data-testid": "builder-inv-results"
      }, /*#__PURE__*/React.createElement("h4", {
        className: "text-xs font-bold text-slate-400 uppercase mt-2 mb-1"
      }, "Investigation results"), /*#__PURE__*/React.createElement(IR.ResultsPanel, {
        rows: rows,
        onEdit: setBuildInvEditing,
        onReset: function onReset(t) {
          return setSpec(t, null);
        },
        resetTitle: "Back to the default",
        intro: "What each investigation button on the patient monitor gives. You can still change them on the controller during the run."
      }), editing && /*#__PURE__*/React.createElement(IR.ResultEditor, {
        type: editing.type,
        current: editing,
        resetLabel: "Default result",
        currentVbg: buildInvResults.VBG && buildInvResults.VBG.vbg ? buildInvResults.VBG.vbg : null,
        onPick: function onPick(spec) {
          return setSpec(editing.type, spec);
        },
        onReset: function onReset() {
          return setSpec(editing.type, null);
        },
        onClose: function onClose() {
          return setBuildInvEditing(null);
        }
      }));
    }(), /*#__PURE__*/React.createElement("h4", {
      className: "text-xs font-bold text-slate-400 uppercase mt-2"
    }, "Initial Observations"), /*#__PURE__*/React.createElement("div", {
      className: "grid grid-cols-3 gap-2"
    }, [['hr', 'Heart Rate'], ['bpSys', 'Sys BP'], ['rr', 'Resp Rate'], ['spO2', 'SpO2 %'], ['gcs', 'GCS'], ['temp', 'Temp °C']].map(function (_ref1) {
      var _ref10 = _slicedToArray(_ref1, 2),
        key = _ref10[0],
        label = _ref10[1];
      return /*#__PURE__*/React.createElement("div", {
        key: key
      }, /*#__PURE__*/React.createElement("label", {
        className: "text-[10px] text-slate-400 uppercase"
      }, label), /*#__PURE__*/React.createElement("input", {
        "aria-label": label,
        type: "number",
        min: BUILDER_LIMITS[key].min,
        max: BUILDER_LIMITS[key].max,
        value: buildVitals[key],
        onChange: function onChange(e) {
          return setBuildVitals(_objectSpread(_objectSpread({}, buildVitals), {}, _defineProperty({}, key, e.target.value)));
        },
        className: fieldClass(builderErrors[key])
      }), /*#__PURE__*/React.createElement(FieldError, {
        msg: builderErrors[key]
      }));
    })), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("label", {
      className: "text-[10px] text-slate-400 uppercase"
    }, "Initial Rhythm"), /*#__PURE__*/React.createElement("select", {
      "aria-label": "Initial Rhythm",
      onChange: function onChange(e) {
        return setBuildVitals(_objectSpread(_objectSpread({}, buildVitals), {}, {
          rhythm: e.target.value
        }));
      },
      className: "w-full bg-slate-900 border border-slate-600 rounded p-2 text-white",
      value: buildVitals.rhythm || "Sinus Rhythm"
    }, (window.RHYTHMS ? window.RHYTHMS.SELECTABLE : ['Sinus Rhythm']).map(function (r) {
      return /*#__PURE__*/React.createElement("option", {
        key: r,
        value: r
      }, window.RHYTHMS ? window.RHYTHMS.labelFor(r) : r);
    }))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("label", {
      className: "text-[10px] text-slate-400 uppercase"
    }, "Human Factors"), /*#__PURE__*/React.createElement("select", {
      "aria-label": "Human Factors",
      value: hf,
      onChange: function onChange(e) {
        return setHf(e.target.value);
      },
      className: "w-full bg-slate-900 border border-slate-600 rounded p-2 text-white"
    }, HUMAN_FACTOR_CHALLENGES.map(function (h) {
      return /*#__PURE__*/React.createElement("option", {
        key: h.id,
        value: h.id
      }, h.type);
    }))), canSave ? /*#__PURE__*/React.createElement("div", {
      className: "grid grid-cols-1 sm:grid-cols-2 gap-2"
    }, /*#__PURE__*/React.createElement(Button, {
      onClick: function onClick() {
        return saveCustomScenario(false);
      },
      variant: "secondary",
      disabled: builderInvalid || saving,
      className: "w-full text-lg h-12"
    }, saving ? 'Saving…' : 'Save'), /*#__PURE__*/React.createElement(Button, {
      onClick: function onClick() {
        return saveCustomScenario(true);
      },
      variant: "primary",
      disabled: builderInvalid || saving,
      className: "w-full text-lg h-12"
    }, "Save and run")) : /*#__PURE__*/React.createElement("div", {
      className: "space-y-2"
    }, /*#__PURE__*/React.createElement(Button, {
      onClick: function onClick() {
        return saveCustomScenario(true);
      },
      variant: "primary",
      disabled: builderInvalid,
      className: "w-full text-lg h-12"
    }, "Run without saving"), /*#__PURE__*/React.createElement("p", {
      className: "text-xs text-slate-400 text-center",
      "data-testid": "builder-save-note"
    }, !accountsOn ? 'Saving needs an account, and accounts are not available right now.' : uid ? 'Your saved scenarios have not loaded, so this cannot be saved yet.' : /*#__PURE__*/React.createElement(React.Fragment, null, "Saving needs an account. ", /*#__PURE__*/React.createElement("button", {
      type: "button",
      onClick: function onClick() {
        return setMyAuthOpen(true);
      },
      className: "underline font-bold text-sky-300"
    }, "Sign in"), " to save this scenario; what you have typed stays here."))), builderInvalid && /*#__PURE__*/React.createElement("p", {
      className: "text-xs text-red-400 text-center"
    }, "Fix the highlighted fields above to run this scenario."), myNotice && /^Not connected/.test(myNotice) && /*#__PURE__*/React.createElement("div", {
      role: "status",
      className: "text-xs bg-amber-950/50 border border-amber-700 rounded p-2 text-amber-200",
      "data-testid": "builder-offline-note"
    }, myNotice)), wetflagOption, AuthModalComponent && myAuthOpen && !uid && /*#__PURE__*/React.createElement(AuthModalComponent, {
      auth: auth,
      onClose: function onClose() {
        if (auth.clearFeedback) auth.clearFeedback();
        setMyAuthOpen(false);
      },
      context: "Sign in to save your scenarios to your account."
    })), /*#__PURE__*/React.createElement(SessionSetupCard, {
      sessionID: sessionID,
      onJoinClick: onJoinClick,
      onNewSessionCode: onNewSessionCode
    }));
  };

  // THE FIRST QUESTION: is this device running the sim, or is it a screen the candidates see?
  // Everything else (what to run, how many screens) comes after, and only for the controller.
  var WelcomeScreen = function WelcomeScreen(_ref11) {
    var onController = _ref11.onController,
      onPatientScreen = _ref11.onPatientScreen;
    var _window3 = window,
      Lucide = _window3.Lucide;
    var card = function card(onClick, testId, icon, title, text) {
      return /*#__PURE__*/React.createElement("button", {
        type: "button",
        onClick: onClick,
        "data-testid": testId,
        "aria-label": title,
        className: "text-left rounded-xl border-2 border-slate-600 bg-slate-800 hover:border-sky-400 hover:bg-slate-700/60 p-6 transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-sky-400 flex flex-col items-start justify-start gap-2"
      }, /*#__PURE__*/React.createElement("div", {
        className: "flex items-center gap-2 text-sky-300"
      }, icon), /*#__PURE__*/React.createElement("div", {
        className: "text-xl font-bold text-white"
      }, title), /*#__PURE__*/React.createElement("div", {
        className: "text-sm text-slate-300 leading-snug"
      }, text));
    };
    return /*#__PURE__*/React.createElement("div", {
      className: "flex flex-col items-center h-full p-4 overflow-y-auto"
    }, /*#__PURE__*/React.createElement("div", {
      className: "w-full max-w-3xl my-auto space-y-6",
      "data-testid": "welcome"
    }, /*#__PURE__*/React.createElement("div", {
      className: "text-center"
    }, /*#__PURE__*/React.createElement("h2", {
      className: "text-2xl sm:text-3xl font-bold text-white"
    }, "What is this device for?"), /*#__PURE__*/React.createElement("p", {
      className: "text-sm text-slate-400 mt-1"
    }, "Each device in the room is one or the other. Open the sim on each device and choose.")), /*#__PURE__*/React.createElement("div", {
      className: "grid grid-cols-1 md:grid-cols-2 gap-4"
    }, card(onController, 'welcome-controller', /*#__PURE__*/React.createElement(Lucide, {
      icon: "sliders",
      className: "w-8 h-8"
    }), 'Controller', 'I am running the sim from here: choosing the patient, changing the obs and following what the team does.'), card(onPatientScreen, 'welcome-screen', /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Lucide, {
      icon: "monitor",
      className: "w-8 h-8"
    }), /*#__PURE__*/React.createElement(Lucide, {
      icon: "zap",
      className: "w-6 h-6"
    }), /*#__PURE__*/React.createElement(Lucide, {
      icon: "wind",
      className: "w-6 h-6"
    })), 'Patient screen', 'This is what the candidates see. Type the code shown on the controller; the controller then chooses whether this screen is the monitor, the defib or the ventilator.')), /*#__PURE__*/React.createElement("p", {
      className: "text-xs text-slate-400 text-center",
      "data-testid": "training-only"
    }, "For simulation training only. Not a medical device and not for real patient care: please don't enter real patient details.")));
  };

  // A patient screen joining a session: just the code. The controller numbers the screen and
  // chooses what it shows.
  var JoinScreen = function JoinScreen(_ref12) {
    var onJoin = _ref12.onJoin,
      onBack = _ref12.onBack;
    var _window4 = window,
      Button = _window4.Button;
    var _useState83 = useState(""),
      _useState84 = _slicedToArray(_useState83, 2),
      code = _useState84[0],
      setCode = _useState84[1];
    var ok = window.isCurrentSessionCode(code);
    return /*#__PURE__*/React.createElement("div", {
      className: "flex flex-col items-center h-full bg-slate-900 text-white p-4 overflow-y-auto"
    }, /*#__PURE__*/React.createElement("div", {
      className: "w-full max-w-xl space-y-5 text-center my-auto"
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex justify-center"
    }, /*#__PURE__*/React.createElement("img", {
      src: "images/emevidence-logo.png",
      alt: "Logo",
      className: "h-20 object-contain"
    })), /*#__PURE__*/React.createElement("h1", {
      className: "text-3xl font-bold text-sky-400"
    }, "Patient screen"), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("label", {
      htmlFor: "join-code",
      className: "block text-slate-300 mb-2"
    }, "Type the session code shown on the controller"), /*#__PURE__*/React.createElement("input", {
      id: "join-code",
      type: "text",
      value: code,
      onChange: function onChange(e) {
        return setCode(e.target.value.toUpperCase().replace(/[^A-Z0-9]/g, ''));
      },
      onKeyDown: function onKeyDown(e) {
        if (e.key === 'Enter' && ok) onJoin(code);
      },
      placeholder: "e.g. K7PQ3M",
      autoCapitalize: "characters",
      autoComplete: "off",
      className: "w-full bg-slate-800 border-2 border-slate-600 rounded-lg p-4 text-center text-3xl font-mono tracking-widest uppercase text-white outline-none",
      maxLength: 6
    })), code.length > 0 && !ok && /*#__PURE__*/React.createElement("p", {
      className: "text-xs text-amber-300"
    }, "The code is the six characters shown on the controller. It never uses O, 0, I, 1 or L."), /*#__PURE__*/React.createElement(Button, {
      onClick: function onClick() {
        return onJoin(code);
      },
      disabled: !ok,
      className: "w-full py-4 text-xl"
    }, "Connect"), /*#__PURE__*/React.createElement("p", {
      className: "text-sm text-slate-400"
    }, "This screen will show a big number. On the controller, under ", /*#__PURE__*/React.createElement("b", null, "Screens"), ", you then choose what each numbered screen shows: the monitor, the defib, the ventilator, or a mix. You can change it at any time."), /*#__PURE__*/React.createElement("p", {
      className: "text-xs text-slate-400"
    }, "Quicker: scan the QR code under ", /*#__PURE__*/React.createElement("b", null, "Connect patient screens"), " (or ", /*#__PURE__*/React.createElement("b", null, "Screens"), " during a scenario) on the controller."), onBack && /*#__PURE__*/React.createElement("button", {
      type: "button",
      onClick: onBack,
      className: "text-sm text-slate-400 underline hover:text-white"
    }, "Back")));
  };
  var BriefingScreen = function BriefingScreen(_ref13) {
    var rawScenario = _ref13.scenario,
      onStart = _ref13.onStart,
      onBack = _ref13.onBack,
      _ref13$sim = _ref13.sim,
      sim = _ref13$sim === void 0 ? null : _ref13$sim;
    var _window5 = window,
      Button = _window5.Button,
      Lucide = _window5.Lucide,
      HumanFactorBadge = _window5.HumanFactorBadge;
    var scenario = rawScenario || {};
    var brief = scenario.instructorBrief || {};
    // Most scenarios start with nothing attached (the team puts the monitoring on). Tick this when the
    // patient is already on a monitor: a ward or resus patient, a transfer, a handover.
    var _useState85 = useState(false),
      _useState86 = _slicedToArray(_useState85, 2),
      monitored = _useState86[0],
      setMonitored = _useState86[1];
    var _useState87 = useState(false),
      _useState88 = _slicedToArray(_useState87, 2),
      showMarkSheet = _useState88[0],
      setShowMarkSheet = _useState88[1];
    var MS = window.MarkScheme;
    var markScheme = MS ? MS.get(scenario) : null;
    return /*#__PURE__*/React.createElement("div", {
      className: "max-w-5xl mx-auto space-y-6 animate-fadeIn p-4 overflow-y-auto h-full"
    }, /*#__PURE__*/React.createElement("div", {
      className: "bg-slate-800 border-l-4 border-sky-500 shadow-lg rounded-lg overflow-hidden"
    }, /*#__PURE__*/React.createElement("div", {
      className: "p-6 bg-slate-800 border-b border-slate-700 flex justify-between items-center"
    }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h2", {
      className: "text-3xl font-bold text-white mb-2"
    }, scenario.title), /*#__PURE__*/React.createElement("div", {
      className: "flex gap-2 mt-2"
    }, /*#__PURE__*/React.createElement("span", {
      className: "bg-slate-700 text-sky-300 text-xs px-2 py-1 rounded border border-slate-600"
    }, scenario.category), /*#__PURE__*/React.createElement("span", {
      className: "bg-slate-700 text-emerald-300 text-xs px-2 py-1 rounded border border-slate-600"
    }, scenario.ageRange), /*#__PURE__*/React.createElement("span", {
      className: "bg-slate-700 text-amber-300 text-xs px-2 py-1 rounded border border-slate-600"
    }, scenario.acuity), /*#__PURE__*/React.createElement(HumanFactorBadge, {
      hf: scenario.hf
    })), scenario.hf && scenario.hf.id !== 'hf0' && /*#__PURE__*/React.createElement("p", {
      className: "text-xs text-fuchsia-300/80 mt-2 max-w-md"
    }, scenario.hf.description)), /*#__PURE__*/React.createElement("div", {
      className: "text-right"
    }, /*#__PURE__*/React.createElement("div", {
      className: "text-[10px] text-slate-400 uppercase font-bold"
    }, "Initial GCS"), /*#__PURE__*/React.createElement("div", {
      className: "text-4xl font-mono font-bold text-white"
    }, scenario.vitals ? scenario.vitals.gcs : '-'))), scenario.ageRange === 'Paediatric' && scenario.wetflag && /*#__PURE__*/React.createElement("div", {
      className: "mx-6 mt-4 p-4 bg-purple-900/20 border border-purple-500/50 rounded-lg"
    }, /*#__PURE__*/React.createElement("h3", {
      className: "text-sm font-bold text-purple-400 uppercase mb-2"
    }, "WETFLAG Calculation (Est. Weight: ", scenario.wetflag.weight, "kg)"), /*#__PURE__*/React.createElement("div", {
      className: "grid grid-cols-3 md:grid-cols-6 gap-2 text-center"
    }, /*#__PURE__*/React.createElement("div", {
      className: "bg-slate-900 p-2 rounded"
    }, /*#__PURE__*/React.createElement("div", {
      className: "text-[9px] text-slate-400 uppercase"
    }, "Energy (4 J/kg)"), /*#__PURE__*/React.createElement("div", {
      className: "font-bold text-white"
    }, scenario.wetflag.energy, " J")), /*#__PURE__*/React.createElement("div", {
      className: "bg-slate-900 p-2 rounded"
    }, /*#__PURE__*/React.createElement("div", {
      className: "text-[9px] text-slate-400 uppercase"
    }, "Tube (ID mm)"), /*#__PURE__*/React.createElement("div", {
      className: "font-bold text-white"
    }, scenario.wetflag.tube), scenario.wetflag.tubeCuffed && scenario.wetflag.tubeUncuffed && /*#__PURE__*/React.createElement("div", {
      className: "text-[10px] text-slate-400"
    }, "uncuffed ", scenario.wetflag.tubeUncuffed)), /*#__PURE__*/React.createElement("div", {
      className: "bg-slate-900 p-2 rounded"
    }, /*#__PURE__*/React.createElement("div", {
      className: "text-[9px] text-slate-400 uppercase"
    }, "Fluids (10 ml/kg)"), /*#__PURE__*/React.createElement("div", {
      className: "font-bold text-white"
    }, scenario.wetflag.fluids, " ml")), /*#__PURE__*/React.createElement("div", {
      className: "bg-slate-900 p-2 rounded"
    }, /*#__PURE__*/React.createElement("div", {
      className: "text-[9px] text-slate-400 uppercase"
    }, "Lorazepam"), /*#__PURE__*/React.createElement("div", {
      className: "font-bold text-white"
    }, scenario.wetflag.lorazepam, " mg")), /*#__PURE__*/React.createElement("div", {
      className: "bg-slate-900 p-2 rounded"
    }, /*#__PURE__*/React.createElement("div", {
      className: "text-[9px] text-slate-400 uppercase"
    }, "Adrenaline"), /*#__PURE__*/React.createElement("div", {
      className: "font-bold text-white"
    }, scenario.wetflag.adrenaline, " mcg")), /*#__PURE__*/React.createElement("div", {
      className: "bg-slate-900 p-2 rounded"
    }, /*#__PURE__*/React.createElement("div", {
      className: "text-[9px] text-slate-400 uppercase"
    }, "10% Glucose (2 ml/kg)"), /*#__PURE__*/React.createElement("div", {
      className: "font-bold text-white"
    }, scenario.wetflag.glucose, " ml")))), /*#__PURE__*/React.createElement("div", {
      className: "grid grid-cols-1 md:grid-cols-2 gap-6 p-6"
    }, /*#__PURE__*/React.createElement("div", {
      className: "space-y-6"
    }, /*#__PURE__*/React.createElement("div", {
      className: "bg-slate-900/50 p-4 rounded border border-slate-700"
    }, /*#__PURE__*/React.createElement("h3", {
      className: "text-sm font-bold text-sky-400 uppercase mb-2 border-b border-slate-700 pb-1"
    }, "Patient Brief"), /*#__PURE__*/React.createElement("p", {
      className: "text-sm text-slate-400 mb-2"
    }, /*#__PURE__*/React.createElement("strong", {
      className: "text-slate-300 uppercase text-xs"
    }, "Patient Name:"), " ", scenario.patientName), /*#__PURE__*/React.createElement("p", {
      className: "text-lg leading-relaxed text-slate-200 mb-4"
    }, scenario.profile), /*#__PURE__*/React.createElement("div", {
      className: "space-y-2 text-sm"
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex"
    }, /*#__PURE__*/React.createElement("span", {
      className: "w-24 text-slate-400 font-bold"
    }, "PMH:"), /*#__PURE__*/React.createElement("span", {
      className: "text-slate-300"
    }, scenario.pmh ? scenario.pmh.join(", ") : 'Nil')), /*#__PURE__*/React.createElement("div", {
      className: "flex"
    }, /*#__PURE__*/React.createElement("span", {
      className: "w-24 text-slate-400 font-bold"
    }, "Rx:"), /*#__PURE__*/React.createElement("span", {
      className: "text-slate-300"
    }, scenario.dhx ? scenario.dhx.join(", ") : 'Nil')), /*#__PURE__*/React.createElement("div", {
      className: "flex"
    }, /*#__PURE__*/React.createElement("span", {
      className: "w-24 text-slate-400 font-bold"
    }, "Allergies:"), /*#__PURE__*/React.createElement("span", {
      className: "text-red-400 font-bold"
    }, scenario.allergies ? scenario.allergies.join(", ") : 'NKDA')))), /*#__PURE__*/React.createElement("div", {
      className: "bg-slate-900/50 p-4 rounded border border-slate-700"
    }, /*#__PURE__*/React.createElement("h3", {
      className: "text-sm font-bold text-purple-400 uppercase mb-2 border-b border-slate-700 pb-1"
    }, "Required Equipment"), /*#__PURE__*/React.createElement("div", {
      className: "flex flex-wrap gap-2"
    }, scenario.equipment && scenario.equipment.map(function (item, i) {
      return /*#__PURE__*/React.createElement("span", {
        key: i,
        className: "text-xs bg-slate-700 text-slate-200 px-2 py-1 rounded border border-slate-600"
      }, item);
    })))), /*#__PURE__*/React.createElement("div", {
      className: "space-y-4"
    }, /*#__PURE__*/React.createElement("div", {
      className: "p-3 bg-amber-900/20 rounded border border-amber-600/30"
    }, /*#__PURE__*/React.createElement("h4", {
      className: "text-sm font-bold text-amber-400 uppercase mb-1"
    }, "Clinical Progression"), /*#__PURE__*/React.createElement("p", {
      className: "text-sm text-slate-300 leading-snug"
    }, brief.progression)), /*#__PURE__*/React.createElement("div", {
      className: "p-3 bg-emerald-900/20 rounded border border-emerald-600/30"
    }, /*#__PURE__*/React.createElement("h4", {
      className: "text-sm font-bold text-emerald-400 uppercase mb-1"
    }, "Key Interventions"), /*#__PURE__*/React.createElement("ul", {
      className: "list-disc pl-4 text-sm text-slate-300 space-y-1"
    }, brief.interventions && brief.interventions.map(function (l, i) {
      return /*#__PURE__*/React.createElement("li", {
        key: i
      }, l);
    }))), /*#__PURE__*/React.createElement("div", {
      className: "p-3 bg-slate-900/50 rounded border border-slate-600"
    }, /*#__PURE__*/React.createElement("h4", {
      className: "text-sm font-bold text-slate-400 uppercase mb-1"
    }, "Guidelines & Resources"), /*#__PURE__*/React.createElement("div", {
      className: "flex flex-col gap-1"
    }, scenario.learningLinks && scenario.learningLinks.map(function (link, i) {
      return /*#__PURE__*/React.createElement("a", {
        key: i,
        href: link.url,
        target: "_blank",
        rel: "noopener noreferrer",
        className: "flex items-center gap-2 text-xs text-sky-400 hover:underline"
      }, /*#__PURE__*/React.createElement(Lucide, {
        icon: "external-link",
        className: "w-3 h-3"
      }), " ", link.label);
    }))), /*#__PURE__*/React.createElement("div", {
      className: "p-3 bg-indigo-900/20 rounded border border-indigo-600/30"
    }, /*#__PURE__*/React.createElement("h4", {
      className: "text-sm font-bold text-indigo-400 uppercase mb-1"
    }, "Learning Objectives"), /*#__PURE__*/React.createElement("ul", {
      className: "list-disc pl-4 text-sm text-slate-300 space-y-1"
    }, (brief.debriefPoints || brief.learningObjectives || []).map(function (l, i) {
      return /*#__PURE__*/React.createElement("li", {
        key: i
      }, l);
    }))), sim && sim.state && sim.state.scenario && window.InvResults && window.Section && /*#__PURE__*/React.createElement(window.Section, {
      id: "briefingInvResults",
      tone: "card",
      title: "Investigation results",
      defaultOpen: false,
      summary: Object.keys(sim.state.scenario.invChanged || {}).length ? "Changed: ".concat(Object.keys(sim.state.scenario.invChanged).join(', ')) : "Scenario's own results \xB7 open to change"
    }, /*#__PURE__*/React.createElement(window.InvResults.LiveResults, {
      sim: sim,
      addLogEntry: sim.addLogEntry,
      canSend: false
    })), markScheme && /*#__PURE__*/React.createElement("div", {
      className: "p-3 bg-fuchsia-900/20 rounded border border-fuchsia-600/40",
      "data-testid": "briefing-marksheet"
    }, /*#__PURE__*/React.createElement("h4", {
      className: "text-sm font-bold text-fuchsia-300 uppercase mb-1"
    }, markScheme.kind === 'assessment' ? 'Team leader assessment' : 'Facilitator pack'), /*#__PURE__*/React.createElement("p", {
      className: "text-xs text-slate-300 mb-2"
    }, "The pathway (each role's findings and expected actions), the results to give and the mark sheet. It stays available from the ", /*#__PURE__*/React.createElement("b", null, "Mark sheet"), " button while the scenario runs."), /*#__PURE__*/React.createElement(Button, {
      onClick: function onClick() {
        return setShowMarkSheet(true);
      },
      variant: "outline",
      className: "h-8 px-3 text-xs"
    }, "Open the mark sheet"))))), /*#__PURE__*/React.createElement("label", {
      className: "flex items-start gap-3 bg-slate-800 border border-slate-700 rounded-lg p-3 cursor-pointer"
    }, /*#__PURE__*/React.createElement("input", {
      type: "checkbox",
      "data-testid": "start-monitored",
      checked: monitored,
      onChange: function onChange(e) {
        return setMonitored(e.target.checked);
      },
      className: "mt-1 w-5 h-5 accent-sky-500"
    }), /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("span", {
      className: "block text-sm font-bold text-white"
    }, "The patient is already on the monitor"), /*#__PURE__*/React.createElement("span", {
      className: "block text-xs text-slate-400"
    }, "ECG, SpO2, NIBP and temperature attached from the start. Leave it unticked when putting the monitoring on is part of the team's task."))), showMarkSheet && MS && /*#__PURE__*/React.createElement(MS.MarkSheetModal, {
      scenario: scenario,
      onClose: function onClose() {
        return setShowMarkSheet(false);
      }
    }), /*#__PURE__*/React.createElement("div", {
      className: "sticky bottom-0 z-10 -mx-1 px-1 py-2 bg-slate-900/95 backdrop-blur flex flex-col md:flex-row gap-4"
    }, /*#__PURE__*/React.createElement(Button, {
      onClick: onBack,
      variant: "secondary",
      className: "flex-1"
    }, "Back to Setup"), /*#__PURE__*/React.createElement(Button, {
      onClick: function onClick() {
        return onStart({
          monitored: monitored
        });
      },
      className: "flex-1 shadow-sky-900/20 shadow-xl h-14 text-xl"
    }, "Start Scenario")));
  };
  window.SetupScreen = SetupScreen;
  window.JoinScreen = JoinScreen;
  window.WelcomeScreen = WelcomeScreen;
  window.BriefingScreen = BriefingScreen;
})();